// Localized priority pages for China, Japan, France and Germany.
// Content is intentionally stored as structured data so the same route, hreflang
// and sitemap rules can be verified in both React and Node build scripts.

export const localizedLocales = {
  "zh-cn": {
    "lang": "zh-CN",
    "short": "中文",
    "name": "简体中文",
    "region": "中国",
    "labels": {
      "localEdition": "本地语言版本",
      "englishOriginal": "查看英文原版",
      "overview": "页面重点",
      "verifiedFacts": "关键信息",
      "searchVocabulary": "本地搜索常用词",
      "evidence": "如何判断证据",
      "related": "相关页面",
      "faq": "常见问题",
      "source": "英文原始页面",
      "language": "语言",
      "updated": "更新时间",
      "home": "首页",
      "read": "打开页面"
    },
    "method": {
      "hub": "内容按主题、企业、机器人型号和真实应用场景组织。页面优先采用官方产品页、研究论文、政府文件和有日期的企业公告，并区分演示、试点、订单、交付和常态化部署。",
      "article": "文中的数字和时间节点保留原始口径。宣传视频不等于自主运行，产能目标不等于实际交付，企业声明也不等于独立审计结果。",
      "robot": "机器人规格以制造商公开资料为准。价格、税费、运输、软件权限和地区版本可能不同，因此页面不会用估算值替代未公开数据。",
      "company": "企业页面区分公司总部、产品线、行业应用和可验证来源。品牌知名度不会被当作机器人自主性或商业部署的证明。",
      "event": "展会只保留主办方已公布日期和地点的未来活动。未确认的届次、过期活动和仅有媒体转述的日期不会列入。"
    },
    "faqQ1": "{subject}页面提供什么内容？",
    "faqQ2": "这些信息如何核实？",
    "faqQ3": "英文原版在哪里？",
    "faqA2": "页面优先引用制造商、研究机构、政府部门和活动主办方的一手资料，并明确标注尚未公开或无法独立确认的内容。",
    "faqA3": "页面顶部和语言切换栏都提供英文原版链接，各语言版本使用独立规范网址。"
  },
  "ja": {
    "lang": "ja",
    "short": "日本語",
    "name": "日本語",
    "region": "日本",
    "labels": {
      "localEdition": "日本語版",
      "englishOriginal": "英語版を見る",
      "overview": "このページの要点",
      "verifiedFacts": "基本情報",
      "searchVocabulary": "日本で使われる検索語",
      "evidence": "情報の読み方",
      "related": "関連ページ",
      "faq": "よくある質問",
      "source": "英語の元ページ",
      "language": "言語",
      "updated": "更新日",
      "home": "ホーム",
      "read": "ページを開く"
    },
    "method": {
      "hub": "テーマ、企業、機体、実証環境ごとに情報を整理しています。公式製品ページ、研究論文、行政資料、日付のある企業発表を優先し、デモ、PoC、受注、納入、常設運用を分けて記載します。",
      "article": "数値と日程は出典の条件を維持しています。映像上の動作を自律運転と断定せず、生産目標と実際の出荷、企業発表と第三者検証を区別します。",
      "robot": "仕様はメーカーの公開情報を基準にしています。価格、税、送料、ソフトウェア利用条件、地域別モデルが異なる場合があるため、未公開項目を推定で埋めません。",
      "company": "本社所在地、製品群、対象産業、確認可能な一次情報を分けて掲載します。企業規模や知名度だけでロボットの自律性や導入実績を評価しません。",
      "event": "主催者が日程と会場を正式発表した今後の展示会のみを掲載します。終了済みのイベント、未確定の次回開催、二次情報だけの日程は除外します。"
    },
    "faqQ1": "{subject}のページでは何が分かりますか？",
    "faqQ2": "情報はどのように確認していますか？",
    "faqQ3": "英語版はどこにありますか？",
    "faqA2": "メーカー、研究機関、行政機関、イベント主催者の一次情報を優先し、未公開事項や独立確認できない主張は明確に分けています。",
    "faqA3": "ページ上部と言語切り替えに英語版へのリンクがあります。各言語版は個別の正規URLを持ちます。"
  },
  "fr": {
    "lang": "fr",
    "short": "FR",
    "name": "Français",
    "region": "France",
    "labels": {
      "localEdition": "Édition française",
      "englishOriginal": "Voir la version anglaise",
      "overview": "Ce que couvre cette page",
      "verifiedFacts": "Données clés",
      "searchVocabulary": "Vocabulaire recherché en français",
      "evidence": "Comment lire les preuves",
      "related": "Pages associées",
      "faq": "Questions fréquentes",
      "source": "Page anglaise d’origine",
      "language": "Langue",
      "updated": "Mise à jour",
      "home": "Accueil",
      "read": "Ouvrir la page"
    },
    "method": {
      "hub": "Le contenu est organisé par sujet, entreprise, robot et environnement de déploiement. Les pages officielles, articles scientifiques, documents publics et annonces datées sont prioritaires. Une démonstration, un pilote, une commande, une livraison et une exploitation régulière restent des preuves différentes.",
      "article": "Les nombres et les échéances conservent le périmètre de leur source. Une vidéo promotionnelle ne prouve pas l’autonomie, un objectif de production ne correspond pas à des livraisons, et une déclaration d’entreprise n’est pas un résultat audité.",
      "robot": "Les caractéristiques viennent des informations publiques du constructeur. Le prix, les taxes, le transport, l’accès logiciel et les versions régionales pouvant changer, aucun chiffre manquant n’est remplacé par une estimation.",
      "company": "La fiche sépare le siège, les gammes de produits, les secteurs servis et les sources vérifiables. La notoriété d’une entreprise ne prouve ni l’autonomie de ses robots ni leur déploiement commercial.",
      "event": "Seuls les salons futurs dont la date et le lieu sont confirmés par l’organisateur sont conservés. Les éditions passées, les prochaines éditions non datées et les calendriers fondés uniquement sur une reprise médiatique sont exclus."
    },
    "faqQ1": "Que contient la page consacrée à {subject} ?",
    "faqQ2": "Comment les informations sont-elles vérifiées ?",
    "faqQ3": "Où trouver la version anglaise ?",
    "faqA2": "Les sources des constructeurs, laboratoires, administrations et organisateurs sont prioritaires. Les éléments non publiés ou non confirmés indépendamment restent signalés comme tels.",
    "faqA3": "Un lien vers la version anglaise figure en haut de la page et dans le sélecteur de langue. Chaque traduction possède sa propre URL canonique."
  },
  "de": {
    "lang": "de",
    "short": "DE",
    "name": "Deutsch",
    "region": "Deutschland",
    "labels": {
      "localEdition": "Deutsche Ausgabe",
      "englishOriginal": "Englische Originalseite",
      "overview": "Inhalt dieser Seite",
      "verifiedFacts": "Geprüfte Angaben",
      "searchVocabulary": "Häufig verwendete deutsche Suchbegriffe",
      "evidence": "So werden Nachweise eingeordnet",
      "related": "Verwandte Seiten",
      "faq": "Häufige Fragen",
      "source": "Englische Originalseite",
      "language": "Sprache",
      "updated": "Aktualisiert",
      "home": "Startseite",
      "read": "Seite öffnen"
    },
    "method": {
      "hub": "Die Inhalte sind nach Themen, Unternehmen, Robotermodellen und Einsatzumgebungen geordnet. Bevorzugt werden offizielle Produktseiten, Forschungsarbeiten, Behördenunterlagen und datierte Unternehmensmeldungen. Demo, Pilotbetrieb, Auftrag, Auslieferung und regulärer Einsatz werden getrennt behandelt.",
      "article": "Zahlen und Termine bleiben an den Umfang ihrer Quelle gebunden. Ein Werbevideo belegt keine Autonomie, ein Produktionsziel ist keine Auslieferungszahl und eine Unternehmensangabe ersetzt keine unabhängige Prüfung.",
      "robot": "Technische Daten beruhen auf veröffentlichten Herstellerangaben. Preis, Steuern, Versand, Softwarezugang und regionale Varianten können abweichen; nicht veröffentlichte Werte werden daher nicht geschätzt.",
      "company": "Unternehmenssitz, Produktlinien, Zielbranchen und überprüfbare Quellen werden getrennt dargestellt. Bekanntheit ist kein Beleg für Autonomie oder einen kommerziellen Robotereinsatz.",
      "event": "Aufgenommen werden nur künftige Veranstaltungen, deren Datum und Ort der Veranstalter bestätigt hat. Vergangene Termine, undatierte Folgeausgaben und reine Medienangaben werden ausgeschlossen."
    },
    "faqQ1": "Welche Informationen bietet die Seite zu {subject}?",
    "faqQ2": "Wie werden die Angaben geprüft?",
    "faqQ3": "Wo befindet sich die englische Version?",
    "faqA2": "Vorrang haben Primärquellen von Herstellern, Forschungseinrichtungen, Behörden und Veranstaltern. Nicht veröffentlichte oder nicht unabhängig bestätigte Aussagen werden entsprechend gekennzeichnet.",
    "faqA3": "Die englische Originalseite ist oben und im Sprachwechsler verlinkt. Jede Sprachfassung besitzt eine eigene kanonische URL."
  }
};

export const localizedKeywordDictionary = {
  "humanoid": {
    "zh-cn": "人形机器人",
    "ja": "ヒューマノイドロボット",
    "fr": "robot humanoïde",
    "de": "humanoide Roboter"
  },
  "physicalAI": {
    "zh-cn": "物理AI",
    "ja": "フィジカルAI",
    "fr": "IA physique",
    "de": "physische KI"
  },
  "embodiedAI": {
    "zh-cn": "具身智能",
    "ja": "エンボディドAI",
    "fr": "intelligence incarnée",
    "de": "verkörperte KI"
  },
  "robotics": {
    "zh-cn": "机器人技术",
    "ja": "ロボティクス",
    "fr": "robotique",
    "de": "Robotik"
  },
  "robotLearning": {
    "zh-cn": "机器人学习",
    "ja": "ロボット学習",
    "fr": "apprentissage robotique",
    "de": "Roboterlernen"
  },
  "industrial": {
    "zh-cn": "工业机器人",
    "ja": "産業用ロボット",
    "fr": "robot industriel",
    "de": "Industrieroboter"
  },
  "automation": {
    "zh-cn": "智能制造",
    "ja": "スマートファクトリー",
    "fr": "automatisation industrielle",
    "de": "industrielle Automatisierung"
  },
  "vla": {
    "zh-cn": "视觉语言动作模型",
    "ja": "視覚言語行動モデル",
    "fr": "modèle vision-langage-action",
    "de": "Vision-Language-Action-Modell"
  },
  "events": {
    "zh-cn": "机器人展会",
    "ja": "ロボット展示会",
    "fr": "salon de la robotique",
    "de": "Robotikmesse"
  },
  "companies": {
    "zh-cn": "机器人公司",
    "ja": "ロボット企業",
    "fr": "entreprise de robotique",
    "de": "Robotikunternehmen"
  },
  "prices": {
    "zh-cn": "人形机器人价格",
    "ja": "ヒューマノイドロボット価格",
    "fr": "prix robot humanoïde",
    "de": "Preis humanoider Roboter"
  },
  "china": {
    "zh-cn": "中国机器人产业",
    "ja": "中国ロボット産業",
    "fr": "robotique chinoise",
    "de": "chinesische Robotik"
  },
  "japan": {
    "zh-cn": "日本机器人产业",
    "ja": "日本のロボット産業",
    "fr": "robotique japonaise",
    "de": "japanische Robotik"
  },
  "wholeBody": {
    "zh-cn": "全身控制",
    "ja": "全身制御",
    "fr": "contrôle du corps entier",
    "de": "Ganzkörperregelung"
  },
  "quadruped": {
    "zh-cn": "四足机器人",
    "ja": "四足歩行ロボット",
    "fr": "robot quadrupède",
    "de": "vierbeiniger Roboter"
  },
  "supply": {
    "zh-cn": "机器人产业链",
    "ja": "ロボット供給網",
    "fr": "chaîne d’approvisionnement robotique",
    "de": "Robotik-Lieferkette"
  },
  "simulation": {
    "zh-cn": "机器人仿真",
    "ja": "ロボットシミュレーション",
    "fr": "simulation robotique",
    "de": "Robotersimulation"
  },
  "news": {
    "zh-cn": "机器人新闻",
    "ja": "ロボットニュース",
    "fr": "actualité robotique",
    "de": "Robotik-News"
  }
};

export const localizedPriorityPages = [
  {
    "key": "home",
    "basePath": "/",
    "pageType": "website",
    "method": "hub",
    "modified": "2026-09-30",
    "keywordKeys": [
      "humanoid",
      "physicalAI",
      "embodiedAI",
      "robotics",
      "news",
      "automation"
    ],
    "subject": {
  "zh-cn": "TechniaHQRobot 机器人媒体",
  "ja": "TechniaHQRobot ロボティクスメディア",
  "fr": "Robots humanoïdes et IA physique TechniaHQRobot",
  "de": "TechniaHQRobot Robotik-Magazin"
},
    "title": {
  "zh-cn": "人形机器人、具身智能与物理AI TechniaHQRobot",
  "ja": "ヒューマノイドとフィジカルAI TechniaHQRobot",
  "fr": "Robots humanoïdes et IA physique TechniaHQRobot",
  "de": "Humanoide Roboter und physische KI TechniaHQRobot"
},
    "description": {
  "zh-cn": "TechniaHQRobot 中文版聚焦人形机器人、具身智能、物理AI、工业机器人、企业、展会和真实部署证据。",
  "ja": "TechniaHQRobot日本語版。ヒューマノイドロボット、フィジカルAI、Embodied AI、ロボット企業、価格、展示会、実機導入を日本語で整理します。メーカー公式資料、研究論文、企業発表を優先し、デモ、試験導入、受注、納入、継続運用を分けて確認できる技術ページへ案内します。更新日も表示します。",
  "fr": "Accès aux pages françaises de TechniaHQ sur les humanoïdes, les entreprises de robotique, la recherche et les événements.",
  "de": "Deutsche TechniaHQRobot-Ausgabe zu humanoiden Robotern, physischer KI, Unternehmen, Messen und überprüfbaren Praxiseinsätzen."
},
    "lead": {
  "zh-cn": "这里汇集机器人型号、企业目录、物理AI研究、展会日程和技术分析。报道会明确区分遥操作、脚本动作、实验室测试、试点项目和长期部署。",
  "ja": "機体カタログ、企業情報、フィジカルAI研究、展示会日程、技術分析をまとめています。遠隔操作、事前プログラム、実験室試験、PoC、継続運用を同じものとして扱いません。",
  "fr": "Cette page rassemble les accès aux modèles de robots, aux entreprises, à la recherche en IA physique et aux événements disponibles en français.",
  "de": "Diese Seite bündelt Robotermodelle, Unternehmen, Forschung zu physischer KI, Veranstaltungen und technische Analysen. Teleoperation, programmierte Abläufe, Labortests, Pilotprojekte und Dauerbetrieb werden klar getrennt."
},
    "facts": [
      {
        "label": {
          "zh-cn": "覆盖范围",
          "ja": "対象範囲",
          "fr": "Périmètre",
          "de": "Abdeckung"
        },
        "value": {
          "zh-cn": "22个重点页面，提供4种本地语言版本",
          "ja": "22の重点ページを4言語で提供",
          "fr": "22 pages prioritaires disponibles dans quatre langues",
          "de": "22 priorisierte Seiten in vier Sprachen"
        }
      },
      {
        "label": {
          "zh-cn": "内容重点",
          "ja": "主な対象",
          "fr": "Sujet principal",
          "de": "Schwerpunkt"
        },
        "value": {
          "zh-cn": "人形机器人、具身智能、物理AI和工业自动化",
          "ja": "ヒューマノイド、フィジカルAI、AIロボティクス、産業自動化",
          "fr": "Robots humanoïdes, IA physique, robotique et automatisation",
          "de": "Humanoide Roboter, physische KI, Robotik und Automatisierung"
        }
      },
      {
        "label": {
          "zh-cn": "证据标准",
          "ja": "証拠の基準",
          "fr": "Niveau de preuve",
          "de": "Nachweisstandard"
        },
        "value": {
          "zh-cn": "优先官方来源，并保留未公开信息",
          "ja": "一次情報を優先し、未公開項目を明示",
          "fr": "Sources officielles prioritaires et données manquantes signalées",
          "de": "Primärquellen zuerst, fehlende Angaben bleiben sichtbar"
        }
      }
    ],
    "related": [
      "humanoid",
      "physical-ai",
      "robotics-news",
      "events"
    ]
  ,
"editorialByLocale": {
  "fr": {
    "modified": "2026-09-29",
    "independentEdition": true,
    "hideEvidence": true,
    "facts": [],
    "related": [
      "physical-ai"
    ],
    "methodText": "Les sources et les limites des informations sont indiquées dans chaque page.",
    "labels": {
      "englishOriginal": "Page en anglais",
      "verifiedFacts": "Informations des sources",
      "evidence": "Sources et méthode"
    }
  }
}
},
  {
    "key": "humanoid",
    "basePath": "/humanoid-robots",
    "pageType": "website",
    "method": "hub",
    "modified": "2026-09-30",
    "keywordKeys": [
      "humanoid",
      "prices",
      "wholeBody",
      "robotLearning",
      "companies",
      "robotics"
    ],
    "subject": {
  "zh-cn": "人形机器人目录",
  "ja": "ヒューマノイドロボット一覧",
  "fr": "Robots humanoïdes : fiches françaises",
  "de": "Katalog humanoider Roboter"
},
    "title": {
  "zh-cn": "人形机器人中文资料与国家专题 TechniaHQRobot",
  "ja": "ヒューマノイドの日本語資料と国別ページ",
  "fr": "Robots humanoïdes : fiches françaises",
  "de": "Humanoide Roboter Katalog, Preise und Daten"
},
    "description": {
  "zh-cn": "浏览 Unitree G1、UBTECH Walker S 的中文资料，以及中国和日本人形机器人专题。完整机器人目录可通过英文页面链接访问。",
  "ja": "Unitree G1、UBTECH Walker Sの日本語資料と、中国・日本のヒューマノイドに関するページへの案内です。全機種のカタログは英語版へのリンクから確認できます。",
  "fr": "Accès aux fiches françaises Unitree G1 et UBTECH Walker S, ainsi qu’aux pages consacrées à la Chine et au Japon.",
  "de": "Überblick über humanoide Roboter mit Links zu Modellprofilen und zum vollständigen englischsprachigen Katalog."
},
    "lead": {
  "zh-cn": "下方提供四个中文页面的链接：Unitree G1、UBTECH Walker S 两份型号资料，以及中国、日本两个国家专题。英文页面提供完整目录。",
  "ja": "下に掲載するのは、Unitree G1とUBTECH Walker Sの機体資料、中国と日本の国別ページの計4件です。全機種のカタログは英語版にあります。",
  "fr": "La sélection ci-dessous rassemble les quatre pages françaises de cette rubrique : deux fiches de robots et deux entrées par pays.",
  "de": "Diese deutschsprachige Übersicht führt zu ausgewählten Modellprofilen. Den vollständigen Katalog mit Herstellerquellen, Preisangaben und Verfügbarkeit finden Sie über den Link zur englischen Originalseite."
},
    "facts": [
      {
        "label": {
          "zh-cn": "机器人型号",
          "ja": "ロボット機種",
          "fr": "Modèles",
          "de": "Robotermodelle"
        },
        "value": {
          "zh-cn": "Unitree G1 和 UBTECH Walker S 两份型号资料",
          "ja": "Unitree G1とUBTECH Walker Sの2機種",
          "fr": "20 fiches de robots humanoïdes structurées",
          "de": "Ausgewählte Modellprofile; vollständiger Katalog auf Englisch"
        }
      },
      {
        "label": {
          "zh-cn": "比较口径",
          "ja": "比較方法",
          "fr": "Méthode de comparaison",
          "de": "Vergleichsmethode"
        },
        "value": {
          "zh-cn": "制造商、国家、价格、尺寸、自由度和可购买状态",
          "ja": "メーカー、国、価格、寸法、自由度、入手状況",
          "fr": "Constructeur, pays, prix, dimensions, degrés de liberté et disponibilité",
          "de": "Hersteller, Land, Preis, Maße, Freiheitsgrade und Verfügbarkeit"
        }
      },
      {
        "label": {
          "zh-cn": "证据标准",
          "ja": "証拠の基準",
          "fr": "Niveau de preuve",
          "de": "Nachweisstandard"
        },
        "value": {
          "zh-cn": "公开价格与询价产品分开显示",
          "ja": "公開価格と要問い合わせを分けて表示",
          "fr": "Prix public séparé des produits sur devis",
          "de": "Öffentliche Preise getrennt von Angeboten auf Anfrage"
        }
      }
    ],
    "related": [
      "unitree-g1",
      "ubtech-walker-s",
      "china-humanoids",
      "japan-humanoids"
    ]
  ,
"editorialByLocale": {
  "fr": {
    "modified": "2026-09-29",
    "independentEdition": true,
    "facts": [],
    "sections": [],
    "hideEvidence": true,
    "labels": {
      "englishOriginal": "Page en anglais",
      "verifiedFacts": "Données publiées",
      "evidence": "Sources et méthode"
    },
    "hideRelated": true
  }
}
},
  {
    "key": "physical-ai",
    "basePath": "/physical-ai",
    "pageType": "website",
    "method": "hub",
    "modified": "2026-08-04",
    "keywordKeys": [
      "physicalAI",
      "embodiedAI",
      "robotLearning",
      "vla",
      "simulation",
      "wholeBody"
    ],
    "subject": {
  "zh-cn": "物理AI与具身智能",
  "ja": "フィジカルAIとエンボディドAI",
  "fr": "IA physique : apprentissage et robotique",
  "de": "physische KI und verkörperte KI"
},
    "title": {
  "zh-cn": "物理AI与具身智能：机器人如何感知和行动",
  "ja": "フィジカルAIとは：ロボットの認識・計画・行動",
  "fr": "IA physique : apprentissage et robotique",
  "de": "Physical AI Vom Aktionsvektor zur Gelenksteuerung"
},
    "description": {
  "zh-cn": "解释物理AI、具身智能、视觉语言动作模型、世界模型、机器人学习、仿真和闭环控制之间的关系。",
  "ja": "フィジカルAI、エンボディドAI、視覚言語行動モデル、世界モデル、シミュレーション、閉ループ制御を解説します。",
  "fr": "Accès aux pages sur l’apprentissage robotique, Xiaomi-Robotics-1 et les robots humanoïdes.",
  "de": "RT-X beschreibt Aktionen im Greiferkoordinatensystem, ein G1-SDK-Beispiel sendet Gelenk-Sollwerte. Warum diese Ausgaben unterschiedliche Größen darstellen."
},
    "lead": {
  "zh-cn": "物理AI把感知、推理和动作连接到真实机器。页面重点解释训练数据来自哪里，模型如何输出动作，以及仿真结果能否迁移到真实机器人。",
  "ja": "フィジカルAIは知覚、推論、動作を実機につなげます。学習データの取得方法、モデルが行動を生成する仕組み、シミュレーションから実機への移行条件を整理します。",
  "fr": "L’IA physique relie perception, raisonnement et action à une machine réelle. Les pages ci-dessous abordent les données d’apprentissage et le matériel robotique.",
  "de": "Physische KI verbindet Wahrnehmung, Schlussfolgerung und Aktion mit realer Hardware. Für die Einordnung eines Robotermodells ist entscheidend, welche Größen seine Ausgabe beschreibt und welcher Regler sie umsetzt."
},
    "facts": [
      {
        "label": {
          "zh-cn": "内容重点",
          "ja": "主な対象",
          "fr": "Sujet principal",
          "de": "Schwerpunkt"
        },
        "value": {
          "zh-cn": "感知、计划、控制、学习和真实环境反馈",
          "ja": "知覚、計画、制御、学習、実環境からのフィードバック",
          "fr": "Perception, planification, contrôle, apprentissage et retour du monde réel",
          "de": "Wahrnehmung, Planung, Regelung, Lernen und Rückmeldung aus der realen Welt"
        }
      },
      {
        "label": {
          "zh-cn": "训练数据",
          "ja": "学習データ",
          "fr": "Données d’entraînement",
          "de": "Trainingsdaten"
        },
        "value": {
          "zh-cn": "真机演示、遥操作、视频、仿真和合成数据",
          "ja": "実機デモ、遠隔操作、動画、シミュレーション、合成データ",
          "fr": "Démonstrations réelles, téléopération, vidéo, simulation et données synthétiques",
          "de": "Reale Demonstrationen, Teleoperation, Video, Simulation und synthetische Daten"
        }
      },
      {
        "label": {
          "zh-cn": "证据标准",
          "ja": "証拠の基準",
          "fr": "Niveau de preuve",
          "de": "Nachweisstandard"
        },
        "value": {
          "zh-cn": "仿真成绩不能直接代表真实部署",
          "ja": "シミュレーション結果を実運用の証明にしない",
          "fr": "Un résultat en simulation ne prouve pas un déploiement réel",
          "de": "Simulationsergebnisse belegen keinen realen Einsatz"
        }
      }
    ],
    "related": [
      "xiaomi",
      "humanoid",
      "robotics-news",
      "events"
    ],
    "sourceLinks": [
      {
        "label": "Open X-Embodiment",
        "url": "https://robotics-transformer-x.github.io/"
      },
      {
        "label": "ROS 2 documentation",
        "url": "https://docs.ros.org/en/rolling/"
      }
    ]
  ,
"editorialByLocale": {
  "de": {
    "facts": [
      {
        "label": {
          "de": "RT-X-Aktionsraum"
        },
        "value": {
          "de": "Position, Orientierung und Greiferöffnung beziehungsweise ihre Änderungsraten"
        }
      },
      {
        "label": {
          "de": "G1-Codebeispiel"
        },
        "value": {
          "de": "Sollposition, Sollgeschwindigkeit, Verstärkungen und Vorsteuerdrehmoment pro Gelenk"
        }
      },
      {
        "label": {
          "de": "Übertragung"
        },
        "value": {
          "de": "Eine gemeinsame Datenstruktur allein belegt keine Übertragbarkeit auf einen anderen Roboter"
        }
      }
    ],
    "sections": [
      {
        "heading": {
          "de": "Sieben Aktionsgrößen sind keine sieben Gelenke"
        },
        "body": {
          "de": "Open X-Embodiment beschreibt für RT-1-X und RT-2-X einen sieben-dimensionalen Aktionsvektor im Greiferkoordinatensystem. Das G1-Armbeispiel arbeitet dagegen mit 29 Gelenkeinträgen. Daraus folgt für einen Vergleich: Die Anzahl der Modellausgaben darf nicht mit den mechanischen Freiheitsgraden gleichgesetzt werden. Eine Verbindung beider Ebenen braucht eine roboterspezifische Abbildung auf erreichbare Gelenkbewegungen und einen passenden Regler. Die beiden Quellen dokumentieren keine gemeinsame RT-X-Integration auf dem G1."
        }
      }
    ],
    "sourceLinks": [
      {
        "label": "Open X-Embodiment und RT-X Aktionsdarstellung",
        "url": "https://robotics-transformer-x.github.io/"
      },
      {
        "label": "Unitree G1 Gelenksteuerung im veröffentlichten SDK",
        "url": "https://github.com/unitreerobotics/unitree_sdk2/blob/8fe9d6e191d3bfa13c99fe3eced8bcb05da8e542/example/g1/low_level/g1_dual_arm_example.cpp"
      }
    ],
    "methodText": "Verglichen werden die beschriebene RT-X-Aktionsdarstellung und die Felder eines veröffentlichten G1-Steuerungsbeispiels. Die Folgerung betrifft die Schnittstellen; sie ist kein Nachweis einer gemeinsamen Implementierung oder eines Robotertests.",
    "labels": {
      "englishOriginal": "Englische Themenseite",
      "verifiedFacts": "Zwei dokumentierte Schnittstellen"
    },
    "related": [
      "xiaomi",
      "unitree-g1",
      "humanoid",
      "robotics-news"
    ],
    "modified": "2026-09-29",
    "independentEdition": true
  },
  "fr": {
    "modified": "2026-09-29",
    "independentEdition": true,
    "facts": [],
    "sections": [],
    "hideEvidence": false,
    "labels": {
      "englishOriginal": "Page en anglais",
      "verifiedFacts": "Données publiées",
      "evidence": "Sources et méthode"
    },
    "related": [
      "xiaomi",
      "humanoid",
      "robotics-news"
    ],
    "sourceLinks": [
      {
        "label": "Open X-Embodiment — données et politiques multi-robots",
        "url": "https://robotics-transformer-x.github.io/"
      }
    ],
    "methodText": "Open X-Embodiment constitue une référence de recherche sur l’apprentissage entre plusieurs robots. Les résultats de cette équipe ne sont pas des essais TechniaHQ."
  }
}
},
  {
    "key": "robotics-news",
    "basePath": "/robotics-news",
    "pageType": "website",
    "method": "hub",
    "modified": "2026-08-04",
    "keywordKeys": [
      "news",
      "humanoid",
      "physicalAI",
      "robotics",
      "industrial",
      "robotLearning"
    ],
    "subject": {
  "zh-cn": "机器人新闻与技术分析",
  "ja": "ロボットニュースと技術分析",
  "fr": "Robotique : dossiers français et actualités",
  "de": "Robotik-News zu humanoiden Robotern und physischer KI"
},
    "title": {
  "zh-cn": "机器人新闻、人形机器人与物理AI分析",
  "ja": "ロボットニュース：ヒューマノイドとフィジカルAI",
  "fr": "Robotique : dossiers français et actualités",
  "de": "Robotik-News zu humanoiden Robotern und physischer KI"
},
    "description": {
  "zh-cn": "阅读关于人形机器人、物理AI、工业自动化、机器人学习、传感器、控制和真实部署的来源核实分析。",
  "ja": "ヒューマノイド、フィジカルAI、産業自動化、センサー、制御、実証導入を一次情報で確認します。",
  "fr": "Sélection de pages françaises sur les entreprises humanoïdes, les prix, les programmes et l’apprentissage robotique.",
  "de": "Deutschsprachige TechniaHQ-Seiten über humanoide Roboter, Hersteller, Preise und Roboterlernen."
},
    "lead": {
  "zh-cn": "新闻页不只重复发布会内容，而是检查机器人名称、任务、传感器、控制方式、演示条件和失败点。时间敏感的信息会保留发布日期与更新时间。",
  "ja": "発表内容をそのまま転載せず、機体名、作業、センサー、制御方式、デモ条件、失敗点を確認します。変化しやすい情報には公開日と更新日を残します。",
  "fr": "Cette rubrique donne accès aux dossiers français sur les entreprises humanoïdes, les prix et les programmes robotiques.",
  "de": "Diese Übersicht führt zu den unten aufgeführten deutschsprachigen Seiten über humanoide Roboter, Unternehmen, Preise und Roboterlernen."
},
    "facts": [
      {
        "label": {
          "zh-cn": "内容重点",
          "ja": "主な対象",
          "fr": "Sujet principal",
          "de": "Schwerpunkt"
        },
        "value": {
          "zh-cn": "机器人硬件、物理AI模型、工厂试点和安全限制",
          "ja": "ロボットハードウェア、フィジカルAIモデル、工場PoC、安全上の制約",
          "fr": "Matériel robotique, modèles d’IA physique, pilotes industriels et sécurité",
          "de": "Roboterhardware, Physical-AI-Modelle, Fabrikpiloten und Sicherheitsgrenzen"
        }
      },
      {
        "label": {
          "zh-cn": "证据标准",
          "ja": "証拠の基準",
          "fr": "Niveau de preuve",
          "de": "Nachweisstandard"
        },
        "value": {
          "zh-cn": "区分宣传、受控实验、客户试点和常态运行",
          "ja": "宣伝、管理された実験、顧客PoC、常設運用を区別",
          "fr": "Distinction entre promotion, expérience contrôlée, pilote client et exploitation",
          "de": "Trennung von Werbung, kontrolliertem Versuch, Kundenpilot und Regelbetrieb"
        }
      },
      {
        "label": {
          "zh-cn": "核实日期",
          "ja": "確認日",
          "fr": "Date de vérification",
          "de": "Prüfdatum"
        },
        "value": {
          "zh-cn": "所有时效性文章保留发布日期和修改日期",
          "ja": "時事記事には公開日と更新日を表示",
          "fr": "Date de publication et de modification conservées",
          "de": "Veröffentlichungs- und Änderungsdatum bleiben sichtbar"
        }
      }
    ],
    "related": [
      "china-companies-article",
      "china-prices",
      "japan-korea",
      "xiaomi"
    ]
  ,
"editorialByLocale": {
  "de": {
    "modified": "2026-09-29",
    "independentEdition": true,
    "hideEvidence": true,
    "facts": [],
    "related": [
      "xiaomi"
    ],
    "methodText": "Die Quellen und Einschränkungen stehen in den jeweiligen Beiträgen.",
    "labels": {
      "englishOriginal": "Seite auf Englisch",
      "verifiedFacts": "Angaben der Quellen",
      "evidence": "Quellen und Methode"
    }
  },
  "fr": {
    "modified": "2026-09-29",
    "independentEdition": true,
    "facts": [],
    "sections": [],
    "hideEvidence": true,
    "labels": {
      "englishOriginal": "Page en anglais",
      "verifiedFacts": "Données publiées",
      "evidence": "Sources et méthode"
    },
    "related": [
      "xiaomi"
    ]
  }
}
},
  {
    "key": "companies-hub",
    "basePath": "/robotics-companies",
    "pageType": "website",
    "method": "company",
    "modified": "2026-08-10",
    "keywordKeys": [
      "companies",
      "robotics",
      "humanoid",
      "industrial",
      "automation",
      "physicalAI"
    ],
    "subject": {
  "zh-cn": "全球机器人公司目录",
  "ja": "世界のロボット企業ディレクトリ",
  "fr": "Entreprises de robotique : fiches françaises",
  "de": "Unternehmensprofile und Länderübersichten"
},
    "title": {
  "zh-cn": "机器人公司目录：制造商、集成商与技术供应商",
  "ja": "ロボット企業ディレクトリ：メーカー・統合会社・技術供給企業",
  "fr": "Entreprises de robotique : fiches françaises",
  "de": "Robotikunternehmen Deutschsprachige Profile"
},
    "description": {
  "zh-cn": "按国家、机器人类型和业务角色查找机器人制造商、系统集成商、软件公司与核心部件供应商，并查看每条记录的官方来源。",
  "ja": "国、ロボット分野、事業形態からメーカー、システムインテグレーター、ソフトウェア企業、部品供給会社を探せる検証済みディレクトリです。",
  "fr": "Accès aux fiches FANUC, Kawasaki Robotics et Yaskawa Electric et aux entrées par pays disponibles dans l’édition française.",
  "de": "Zugang zu den deutschen Unternehmensprofilen von FANUC, Kawasaki Robotics und Yaskawa sowie zu den Länderübersichten für China und Japan."
},
    "lead": {
  "zh-cn": "本目录用于确认一家企业实际开发或提供什么，而不是重复营销口号。每条记录都会区分整机制造商、系统集成商、软件供应商、部件公司和研究机构，并链接到能够证明当前业务活动的官方页面。",
  "ja": "このディレクトリは、企業の宣伝文句ではなく、実際に開発・提供している製品やサービスを確認するためのものです。完成機メーカー、システムインテグレーター、ソフトウェア会社、部品企業、研究組織を分け、現在の活動を示す公式ページへリンクします。",
  "fr": "Cette rubrique rassemble trois profils d’entreprises japonaises et les pages françaises par pays.",
  "de": "Hier finden Sie die bestehenden deutschen Unternehmensprofile von FANUC, Kawasaki Robotics und Yaskawa. Die Länderübersichten verweisen auf weitere TechniaHQ-Seiten. Der englische Bereich enthält das ausführlichere Unternehmensverzeichnis."
},
    "facts": [
      {
        "label": {
          "zh-cn": "企业类型",
          "ja": "企業区分",
          "fr": "Types d’entreprises",
          "de": "Unternehmenstypen"
        },
        "value": {
          "zh-cn": "整机制造商、系统集成商、软件公司、部件供应商和研究组织分别标注",
          "ja": "完成機メーカー、統合会社、ソフトウェア企業、部品供給会社、研究組織を個別に表示",
          "fr": "Fabricants, intégrateurs, logiciels, composants et recherche sont identifiés séparément",
          "de": "Hersteller, Integratoren, Software, Komponenten und Forschung werden getrennt gekennzeichnet"
        }
      },
      {
        "label": {
          "zh-cn": "收录标准",
          "ja": "掲載基準",
          "fr": "Critère d’inclusion",
          "de": "Aufnahmekriterium"
        },
        "value": {
          "zh-cn": "至少需要一个当前可访问的公司官网、产品页或其他第一方来源",
          "ja": "現行の公式サイト、製品ページ、または一次情報を最低一つ確認",
          "fr": "Au moins un site officiel, une page produit ou une autre source de première main active",
          "de": "Mindestens eine aktuelle offizielle Website, Produktseite oder andere Primärquelle"
        }
      },
      {
        "label": {
          "zh-cn": "分类维度",
          "ja": "分類軸",
          "fr": "Classement",
          "de": "Klassifizierung"
        },
        "value": {
          "zh-cn": "国家、洲、机器人类别、公司角色和主要应用行业",
          "ja": "国、地域、ロボット分類、企業の役割、主な導入業界",
          "fr": "Pays, continent, catégorie de robot, rôle de l’entreprise et secteurs servis",
          "de": "Land, Kontinent, Roboterkategorie, Unternehmensrolle und bediente Branchen"
        }
      },
      {
        "label": {
          "zh-cn": "能力表述",
          "ja": "能力の表記",
          "fr": "Niveau de capacité",
          "de": "Fähigkeitsangaben"
        },
        "value": {
          "zh-cn": "遥操作、预编程、试点部署和持续自主运行不会被混为一谈",
          "ja": "遠隔操作、事前プログラム、実証導入、継続的な自律運用を混同しない",
          "fr": "Téléopération, programmation, pilote et autonomie continue ne sont pas présentés comme équivalents",
          "de": "Teleoperation, Programmierung, Pilotbetrieb und dauerhafte Autonomie werden nicht gleichgesetzt"
        }
      }
    ],
    "sections": [
      {
        "heading": {
          "zh-cn": "目录收录哪些机器人企业",
          "ja": "掲載するロボット企業",
          "fr": "Entreprises couvertes par l’annuaire",
          "de": "Welche Robotikunternehmen erfasst werden"
        },
        "body": {
          "zh-cn": "收录范围包括工业机械臂、协作机器人、自主移动机器人、人形机器人、医疗机器人、无人机、传感器、执行器、控制软件和机器人数据服务。企业可以出现在多个类别中，但必须有官方材料证明每项业务。仅转售通用设备而没有明确机器人产品或集成服务的公司不会自动被列为制造商。",
          "ja": "産業用アーム、協働ロボット、自律移動ロボット、ヒューマノイド、医療ロボット、ドローン、センサー、アクチュエーター、制御ソフトウェア、ロボット学習データを対象にします。複数分野に掲載する場合は、それぞれの事業を示す公式資料が必要です。一般機器の再販だけを行う会社をロボットメーカーとして扱いません。",
          "fr": "L’annuaire couvre les bras industriels, cobots, robots mobiles autonomes, humanoïdes, robots médicaux, drones, capteurs, actionneurs, logiciels de contrôle et services de données robotiques. Une société peut appartenir à plusieurs catégories si ses documents officiels confirment chaque activité. Un simple revendeur de matériel générique n’est pas automatiquement présenté comme fabricant.",
          "de": "Das Verzeichnis umfasst Industrieroboter, Cobots, autonome mobile Roboter, Humanoide, Medizinrobotik, Drohnen, Sensoren, Aktuatoren, Steuerungssoftware und Robotikdaten. Ein Unternehmen kann mehreren Kategorien angehören, wenn offizielle Unterlagen jede Tätigkeit belegen. Ein reiner Händler allgemeiner Technik wird nicht automatisch als Roboterhersteller geführt."
        }
      },
      {
        "heading": {
          "zh-cn": "如何验证企业记录",
          "ja": "企業情報の検証方法",
          "fr": "Comment les fiches sont vérifiées",
          "de": "Wie Unternehmenseinträge geprüft werden"
        },
        "body": {
          "zh-cn": "验证从公司官网、产品文档、技术论文、监管文件和带日期的企业公告开始。目录记录公司所在国家、产品类别和最近核查日期。短视频中的动作不会自动证明完全自主；如果官方资料显示遥操作、动作捕捉或受控试验，页面会保留这一条件。无法确认的价格、出货量或部署规模不会被估算。",
          "ja": "確認には公式サイト、製品資料、技術論文、規制資料、日付のある企業発表を使います。所在地、製品分類、最終確認日を記録します。短い動画だけで完全自律とは判断せず、遠隔操作、モーションキャプチャ、管理された試験である場合は条件を明記します。確認できない価格、出荷数、導入規模は推定しません。",
          "fr": "La vérification commence par le site de l’entreprise, ses documents produit, publications techniques, dossiers réglementaires et annonces datées. La fiche conserve le pays, les catégories et la date de contrôle. Une courte vidéo ne prouve pas une autonomie complète  téléopération, capture de mouvement et essai contrôlé restent signalés. Les prix, livraisons ou volumes non confirmés ne sont pas estimés.",
          "de": "Geprüft werden offizielle Websites, Produktunterlagen, Fachveröffentlichungen, regulatorische Dokumente und datierte Unternehmensmeldungen. Land, Produktkategorien und letztes Prüfdatum bleiben sichtbar. Ein kurzes Video belegt keine vollständige Autonomie; Teleoperation, Motion-Capture und kontrollierte Tests werden benannt. Nicht bestätigte Preise, Lieferzahlen oder Einsatzmengen werden nicht geschätzt."
        }
      },
      {
        "heading": {
          "zh-cn": "比较机器人供应商时应检查什么",
          "ja": "ロボット供給会社を比較する要点",
          "fr": "Points à contrôler avant de choisir un fournisseur",
          "de": "Was vor der Lieferantenauswahl zu prüfen ist"
        },
        "body": {
          "zh-cn": "先明确机器人需要完成的任务、工作空间、负载、速度和安全要求，再比较集成成本、维护、备件、软件更新、服务地区和已验证的部署。演示成功并不代表机器人能在客户现场连续运行。采购前应要求与目标环境相似的测试结果、故障处理方式和人工介入频率。",
          "ja": "必要な作業、動作範囲、可搬重量、速度、安全条件を先に定義し、統合費用、保守、交換部品、ソフトウェア更新、対応地域、検証済み導入例を比較します。デモの成功は顧客現場での連続稼働を意味しません。購入前に、近い環境での試験結果、故障時の対応、人の介入頻度を確認する必要があります。",
          "fr": "Définissez d’abord la tâche, l’espace de travail, la charge, la vitesse et les exigences de sécurité. Comparez ensuite l’intégration, la maintenance, les pièces, les mises à jour, la zone de service et les déploiements vérifiés. Une démonstration réussie ne garantit pas un fonctionnement continu chez le client. Demandez des essais proches de votre environnement, le traitement des pannes et la fréquence d’intervention humaine.",
          "de": "Definieren Sie zuerst Aufgabe, Arbeitsraum, Nutzlast, Geschwindigkeit und Sicherheitsanforderungen. Vergleichen Sie danach Integration, Wartung, Ersatzteile, Updates, Servicegebiet und belegte Einsätze. Eine erfolgreiche Demonstration garantiert keinen Dauerbetrieb beim Kunden. Verlangen Sie Tests in ähnlichen Umgebungen, Angaben zur Fehlerbehandlung und zur Häufigkeit menschlicher Eingriffe."
        }
      }
    ],
    "related": [
      "china-companies-directory",
      "japan-companies-directory",
      "humanoid",
      "physical-ai"
    ]
  ,
"editorialByLocale": {
  "de": {
    "facts": [],
    "sections": [],
    "hideEvidence": true,
    "related": [],
    "modified": "2026-09-29",
    "independentEdition": true,
    "labels": {
      "englishOriginal": "Englische Themenseite"
    },
    "hideRelated": true
  },
  "fr": {
    "modified": "2026-09-29",
    "independentEdition": true,
    "facts": [],
    "sections": [],
    "hideEvidence": true,
    "labels": {
      "englishOriginal": "Page en anglais",
      "verifiedFacts": "Données publiées",
      "evidence": "Sources et méthode"
    },
    "related": [
      "humanoid",
      "physical-ai"
    ]
  }
}
},
  {
  "key": "events-hub",
  "basePath": "/robotics-events",
  "pageType": "website",
  "method": "event",
  "modified": "2026-08-10",
  "keywordKeys": [
    "events",
    "robotics",
    "humanoid",
    "physicalAI",
    "industrial",
    "automation"
  ],
  "subject": {
    "zh-cn": "机器人活动：主办方与展会入口",
    "ja": "ロボットイベント：主催者と展示会への入口",
    "fr": "Événements robotiques : sites organisateurs",
    "de": "Robotikveranstaltungen: Veranstalter und Messeübersicht"
  },
  "title": {
    "zh-cn": "机器人活动：主办方与展会入口",
    "ja": "ロボットイベント：主催者と展示会への入口",
    "fr": "Événements robotiques : sites organisateurs",
    "de": "Robotikveranstaltungen: Veranstalter und Messeübersicht"
  },
  "description": {
    "zh-cn": "Automate、RoboCup 的官方入口和机器人展会资料链接。",
    "ja": "AutomateとRoboCupの公式入口、およびロボット展示会の関連資料。",
    "fr": "Accès aux sites d’Automate et de la RoboCup et à la rubrique consacrée aux salons robotiques.",
    "de": "Links zu Robotikveranstaltern und zur deutschen Messeübersicht. Diese Seite enthält derzeit keine datierten Veranstaltungseinträge."
  },
  "lead": {
    "zh-cn": "这里提供 Automate 和 RoboCup 主办方链接以及展会主题入口。本页没有按日期列出的活动记录。",
    "ja": "AutomateとRoboCupの主催者サイトと展示会ページへのリンクです。このページには日付付きイベント記録はありません。",
    "fr": "Les sites officiels d’Automate et de la RoboCup donnent accès aux programmes et informations de leurs éditions.",
    "de": "Hier finden Sie Links zu Automate und RoboCup sowie zur Messeübersicht. Datierte Veranstaltungseinträge sind auf dieser Seite derzeit nicht vorhanden."
  },
  "facts": [
    {
      "label": {
        "zh-cn": "活动类型",
        "ja": "イベント形式",
        "fr": "Formats couverts",
        "de": "Veranstaltungsarten"
      },
      "value": {
        "zh-cn": "商业展会、学术会议、技术峰会、竞赛、培训和线上活动",
        "ja": "商業展示会、学術会議、技術サミット、競技会、研修、オンラインイベント",
        "fr": "Salons professionnels, conférences, sommets, compétitions, formations et événements en ligne",
        "de": "Fachmessen, Konferenzen, Gipfeltreffen, Wettbewerbe, Schulungen und Onlineevents"
      }
    },
    {
      "label": {
        "zh-cn": "必要信息",
        "ja": "必須情報",
        "fr": "Informations requises",
        "de": "Pflichtangaben"
      },
      "value": {
        "zh-cn": "主办方、日期、地点或线上形式以及官方活动页面",
        "ja": "主催者、日程、会場またはオンライン形式、公式イベントページ",
        "fr": "Organisateur, dates, lieu ou format en ligne et page officielle",
        "de": "Veranstalter, Datum, Ort oder Onlineformat und offizielle Veranstaltungsseite"
      }
    },
    {
      "label": {
        "zh-cn": "状态管理",
        "ja": "ステータス管理",
        "fr": "Gestion du statut",
        "de": "Statusverwaltung"
      },
      "value": {
        "zh-cn": "开放注册、注册关闭、延期、取消和结束状态分别显示",
        "ja": "受付中、受付終了、延期、中止、終了を分けて表示",
        "fr": "Inscriptions ouvertes ou closes, report, annulation et fin sont distingués",
        "de": "Offene oder geschlossene Anmeldung, Verschiebung, Absage und Ende werden getrennt angezeigt"
      }
    },
    {
      "label": {
        "zh-cn": "旅行前核查",
        "ja": "渡航前の確認",
        "fr": "Contrôle avant déplacement",
        "de": "Prüfung vor der Reise"
      },
      "value": {
        "zh-cn": "预订交通和酒店之前再次查看主办方的最新日期、场馆和入场规则",
        "ja": "交通や宿泊の予約前に主催者の最新日程、会場、入場条件を再確認",
        "fr": "Revérifier dates, lieu et conditions d’accès auprès de l’organisateur avant toute réservation",
        "de": "Vor Buchungen Datum, Ort und Zugangsregeln erneut beim Veranstalter prüfen"
      }
    }
  ],
  "sections": [
    {
      "heading": {
        "zh-cn": "日历中包含哪些机器人活动",
        "ja": "カレンダーに掲載するイベント",
        "fr": "Événements présents dans le calendrier",
        "de": "Welche Robotikveranstaltungen enthalten sind"
      },
      "body": {
        "zh-cn": "日历覆盖工业机器人与自动化展会、人形机器人和具身智能峰会、机器人研究会议、大学与企业比赛、开发者研讨会以及线上培训。大型综合技术展只有在机器人或物理AI拥有明确议程时才会进入相关分类。活动名称相似并不代表由同一组织举办，页面会保留主办方和官方域名。",
        "ja": "産業ロボット・自動化展、ヒューマノイドとエンボディドAIのサミット、ロボット研究会議、大学・企業の競技会、開発者向けワークショップ、オンライン研修を扱います。総合技術イベントは、ロボティクスやフィジカルAIの明確なプログラムがある場合に掲載します。似た名称でも主催者が異なるため、公式組織とドメインを保持します。",
        "fr": "Le calendrier couvre les salons d’automatisation, sommets sur les humanoïdes et l’IA incarnée, conférences scientifiques, compétitions universitaires ou industrielles, ateliers développeurs et formations en ligne. Un grand salon technologique généraliste n’est retenu que s’il possède un programme robotique ou IA physique identifiable. Les noms proches ne suffisent pas  l’organisateur et son domaine officiel restent visibles.",
        "de": "Erfasst werden Industrie- und Automationsmessen, Gipfel zu Humanoiden und verkörperter KI, Forschungskonferenzen, Hochschul- und Unternehmenswettbewerbe, Entwicklerworkshops und Onlinekurse. Allgemeine Technikveranstaltungen erscheinen nur bei einem klaren Robotik- oder Physical-AI-Programm. Ähnliche Namen bedeuten nicht denselben Veranstalter; Organisation und offizielle Domain bleiben sichtbar."
      }
    },
    {
      "heading": {
        "zh-cn": "日期、场馆和注册状态如何核实",
        "ja": "日程・会場・登録状況の確認方法",
        "fr": "Vérification des dates, lieux et inscriptions",
        "de": "Prüfung von Termin, Ort und Anmeldung"
      },
      "body": {
        "zh-cn": "优先采用主办方、场馆、专业协会或大学发布的日期。媒体报道可以帮助发现活动，但不能替代官方确认。如果日期延期、场馆更换或注册关闭，状态应根据带日期的最新公告更新。没有确定日期的下一届活动不会被写成已经确认。线上活动也需要明确时区和访问条件。",
        "ja": "主催者、会場、業界団体、大学が発表した日程を優先します。報道はイベント発見に役立ちますが、公式確認の代わりにはなりません。延期、会場変更、受付終了は最新の発表に合わせて更新します。次回開催の日付が未定なら確定済みとは書きません。オンラインイベントではタイムゾーンと参加条件も確認します。",
        "fr": "Les dates publiées par l’organisateur, le lieu, une association professionnelle ou une université sont prioritaires. Un article de presse peut révéler un événement, mais ne remplace pas sa confirmation. Report, changement de salle ou fermeture des inscriptions sont mis à jour depuis l’annonce datée la plus récente. Une prochaine édition sans date n’est jamais présentée comme confirmée. Les événements en ligne doivent préciser fuseau horaire et accès.",
        "de": "Vorrang haben Termine des Veranstalters, Veranstaltungsorts, Fachverbands oder einer Hochschule. Medienberichte können eine Veranstaltung auffindbar machen, ersetzen aber keine Bestätigung. Verschiebungen, Ortswechsel und Anmeldeschluss werden anhand der neuesten datierten Meldung aktualisiert. Eine Ausgabe ohne festes Datum gilt nicht als bestätigt. Onlineevents benötigen außerdem Zeitzone und Zugangsbedingungen."
      }
    },
    {
      "heading": {
        "zh-cn": "如何选择值得参加的活动",
        "ja": "参加イベントの選び方",
        "fr": "Choisir un événement adapté à son objectif",
        "de": "Die passende Veranstaltung auswählen"
      },
      "body": {
        "zh-cn": "工程师应查看技术议程、论文和开发者课程；采购团队应关注参展商、现场演示和供应商会议；研究人员则应核对投稿截止日期、评审流程和论文集。人形机器人短暂登台并不等于现场展示可重复部署。出行前还要检查签证、门票、观众资格、摄影规则和演示是否需要预约。",
        "ja": "技術者は技術セッション、論文、開発者講座を確認し、調達担当者は出展企業、実機デモ、商談機会を見ます。研究者は投稿締切、査読方式、予稿集を確認します。ヒューマノイドが短時間登場しても、反復可能な導入実証とは限りません。渡航前にビザ、料金、参加資格、撮影規則、デモ予約の要否も確認してください。",
        "fr": "Les ingénieurs regarderont le programme technique, les articles et ateliers développeurs. Les acheteurs vérifieront exposants, démonstrations et rendez-vous fournisseurs. Les chercheurs contrôleront les échéances de soumission, l’évaluation et les actes. Une apparition brève d’un humanoïde sur scène ne prouve pas un déploiement reproductible. Avant le départ, vérifiez visa, billet, admissibilité, règles photo et réservation des démonstrations.",
        "de": "Ingenieure sollten Technikprogramm, Fachbeiträge und Entwicklerkurse prüfen; Einkaufsteams Aussteller, Vorführungen und Lieferantentermine; Forschende Einreichungsfristen, Begutachtung und Proceedings. Ein kurzer Humanoid-Auftritt auf der Bühne belegt keinen wiederholbaren Einsatz. Vor der Reise sind Visum, Ticket, Teilnahmebedingungen, Fotoregeln und nötige Demo-Reservierungen zu prüfen."
      }
    }
  ],
  "related": [
    "events",
    "physical-ai",
    "robotics-news",
    "home"
  ],
  "sourceLinks": [
    {
      "label": "Automate — organizer",
      "url": "https://www.automateshow.com/"
    },
    {
      "label": "RoboCup Federation",
      "url": "https://www.robocup.org/"
    }
  ],
  "editorialByLocale": {
    "de": {
      "modified": "2026-09-29",
      "independentEdition": true,
      "hideEvidence": false,
      "facts": [],
      "sections": [],
      "related": [
        "events"
      ],
      "methodText": "Termine und Anmeldung stehen auf den verlinkten Veranstalterseiten.",
      "labels": {
        "englishOriginal": "Seite auf Englisch",
        "verifiedFacts": "Angaben der Quellen",
        "evidence": "Quellen und Methode"
      }
    },
    "fr": {
      "modified": "2026-09-29",
      "independentEdition": true,
      "facts": [],
      "sections": [],
      "hideEvidence": false,
      "labels": {
        "englishOriginal": "Page en anglais",
        "verifiedFacts": "Données publiées",
        "evidence": "Sources et méthode"
      },
      "related": [],
      "methodText": "Cette page fournit des liens d’organisateurs. Elle ne présente actuellement aucune liste d’événements datés.",
      "sourceLinks": [
        {
          "label": "Automate — organizer",
          "url": "https://www.automateshow.com/"
        },
        {
          "label": "RoboCup Federation",
          "url": "https://www.robocup.org/"
        }
      ],
      "hideRelated": true
    },
    "zh-cn": {
      "independentEdition": true,
      "labels": {
        "englishOriginal": "英文页面",
        "verifiedFacts": "阅读要点"
      },
      "facts": [],
      "methodText": "下方链接指向主办方；活动日期和报名条件以该站点公布为准。"
    },
    "ja": {
      "independentEdition": true,
      "labels": {
        "englishOriginal": "英語ページ",
        "verifiedFacts": "確認項目"
      },
      "facts": [],
      "methodText": "下記は主催者へのリンクです。日程と申込条件は各サイトで確認してください。"
    }
  }
},
  {
  "key": "events",
  "basePath": "/robotics-events/exhibitions",
  "pageType": "website",
  "method": "event",
  "modified": "2026-08-04",
  "keywordKeys": [
    "events",
    "humanoid",
    "physicalAI",
    "industrial",
    "robotics",
    "automation"
  ],
  "subject": {
    "zh-cn": "机器人展会：Automate与世界机器人大会",
    "ja": "ロボット展示会：AutomateとWorld Robot Conference",
    "fr": "Salons robotiques : Automate et World Robot Conference",
    "de": "Robotikmessen: Links zu den Veranstaltern"
  },
  "title": {
    "zh-cn": "机器人展会：Automate与世界机器人大会",
    "ja": "ロボット展示会：AutomateとWorld Robot Conference",
    "fr": "Salons robotiques : Automate et World Robot Conference",
    "de": "Robotikmessen: Links zu den Veranstaltern"
  },
  "description": {
    "zh-cn": "通过 Automate 和 World Robot Conference 官方网站查看展会计划和参加条件。",
    "ja": "AutomateとWorld Robot Conferenceの公式サイトで開催情報と参加条件を確認するためのリンク。",
    "fr": "Liens officiels d’Automate et de la World Robot Conference pour consulter leurs programmes et informations d’accès.",
    "de": "Offizielle Links zu Automate und World Robot Conference. Ein nach Datum oder Land filterbarer Messekalender ist hier nicht vorhanden."
  },
  "lead": {
    "zh-cn": "下方是 Automate 和 World Robot Conference 官方入口。具体日期、会场和报名条件请在主办方页面核实；这里不是可按国家和日期筛选的活动日历。",
    "ja": "下記はAutomateとWorld Robot Conferenceの公式入口です。日程、会場、申込条件は主催者サイトで確認してください。国や日付で絞り込むイベントカレンダーではありません。",
    "fr": "Les sites d’Automate et de la World Robot Conference publient les informations de leurs éditions.",
    "de": "Automate und World Robot Conference veröffentlichen ihre Programme auf den unten verlinkten Websites. Diese Übersicht enthält derzeit keine einzelnen Messetermine."
  },
  "facts": [
    {
      "label": {
        "zh-cn": "覆盖范围",
        "ja": "対象範囲",
        "fr": "Périmètre",
        "de": "Abdeckung"
      },
      "value": {
        "zh-cn": "机器人、工业自动化、人形机器人、物理AI和研究会议",
        "ja": "ロボティクス、産業自動化、ヒューマノイド、フィジカルAI、研究会議",
        "fr": "Robotique, automatisation, humanoïdes, IA physique et conférences scientifiques",
        "de": "Robotik, Industrieautomation, Humanoide, physische KI und Forschungskonferenzen"
      }
    },
    {
      "label": {
        "zh-cn": "证据标准",
        "ja": "証拠の基準",
        "fr": "Niveau de preuve",
        "de": "Nachweisstandard"
      },
      "value": {
        "zh-cn": "只采用主办方确认的日期和地点",
        "ja": "主催者確認済みの日程と会場のみ",
        "fr": "Dates et lieux confirmés par l’organisateur",
        "de": "Nur vom Veranstalter bestätigte Termine und Orte"
      }
    },
    {
      "label": {
        "zh-cn": "状态",
        "ja": "状態",
        "fr": "Statut",
        "de": "Status"
      },
      "value": {
        "zh-cn": "过期活动和未定日期不进入当前列表",
        "ja": "終了済み・日程未定のイベントは現行一覧から除外",
        "fr": "Événements passés et éditions non datées exclus",
        "de": "Vergangene und undatierte Veranstaltungen ausgeschlossen"
      }
    }
  ],
  "related": [
    "home",
    "physical-ai",
    "robotics-news",
    "japan-humanoids"
  ],
  "sourceLinks": [
    {
      "label": "Automate — organizer",
      "url": "https://www.automateshow.com/"
    },
    {
      "label": "World Robot Conference — organizer",
      "url": "https://www.worldrobotconference.com/en/"
    }
  ],
  "editorialByLocale": {
    "de": {
      "modified": "2026-09-29",
      "independentEdition": true,
      "hideEvidence": false,
      "facts": [],
      "sections": [],
      "related": [
        "events-hub"
      ],
      "methodText": "Programme, Termine und Anmeldung beim jeweiligen Veranstalter prüfen.",
      "labels": {
        "englishOriginal": "Seite auf Englisch",
        "verifiedFacts": "Angaben der Quellen",
        "evidence": "Quellen und Methode"
      }
    },
    "fr": {
      "modified": "2026-09-29",
      "independentEdition": true,
      "facts": [],
      "sections": [],
      "hideEvidence": false,
      "labels": {
        "englishOriginal": "Page en anglais",
        "verifiedFacts": "Données publiées",
        "evidence": "Sources et méthode"
      },
      "related": [
        "events-hub"
      ],
      "methodText": "Les dates et lieux doivent être consultés sur l’édition concernée du site organisateur ; aucun calendrier daté n’est présenté ici.",
      "sourceLinks": [
        {
          "label": "Automate — organizer",
          "url": "https://www.automateshow.com/"
        },
        {
          "label": "World Robot Conference — organizer",
          "url": "https://www.worldrobotconference.com/en/"
        }
      ]
    },
    "zh-cn": {
      "independentEdition": true,
      "labels": {
        "englishOriginal": "英文页面",
        "verifiedFacts": "阅读要点"
      },
      "facts": [],
      "methodText": "下方链接指向主办方；活动日期和报名条件以该站点公布为准。"
    },
    "ja": {
      "independentEdition": true,
      "labels": {
        "englishOriginal": "英語ページ",
        "verifiedFacts": "確認項目"
      },
      "facts": [],
      "methodText": "下記は主催者へのリンクです。日程と申込条件は各サイトで確認してください。"
    }
  }
},
  {
    "key": "china-humanoids",
    "basePath": "/humanoid-robots/china",
    "pageType": "article",
    "method": "article",
    "modified": "2026-09-30",
    "keywordKeys": [
      "china",
      "humanoid",
      "embodiedAI",
      "physicalAI",
      "supply",
      "automation"
    ],
    "subject": {
  "zh-cn": "中国人形机器人产业",
  "ja": "中国のヒューマノイドロボット産業",
  "fr": "Robots humanoïdes chinois : pages disponibles",
  "de": "Links zu chinesischen Humanoiden"
},
    "title": {
  "zh-cn": "中国人形机器人：企业、型号与具身智能产业链",
  "ja": "中国のヒューマノイド企業・機体・供給網",
  "fr": "Robots humanoïdes chinois : pages disponibles",
  "de": "Chinesische humanoide Roboter Profile und Themen"
},
    "description": {
  "zh-cn": "梳理中国人形机器人企业、机器人型号、具身智能、关键零部件、公开价格、工厂试点和证据限制。",
  "ja": "中国のヒューマノイドロボットを企業、機体、価格、仕様、部品供給網、工場実証、フィジカルAIの観点で整理。メーカー公式情報を基に、公開価格、自由度、用途、販売状況を確認し、発表、試験導入、注文、納入、量産計画を区別します。未公開の仕様は推定せず、各機体の出典と確認日を残しています。メーカー別ページにも移れます。",
  "fr": "Liens vers les fiches Unitree G1 et UBTECH Walker S et les dossiers français consacrés aux humanoïdes chinois.",
  "de": "Deutschsprachige Links zu Unitree G1, UBTECH Walker S und weiteren TechniaHQ-Seiten über chinesische Humanoide und ihre Preisangaben."
},
    "lead": {
  "zh-cn": "中国市场的进展不仅来自整机品牌，还取决于电机、减速器、电池、灵巧手、传感器、数据和制造能力。页面会把整机厂、集成商、零部件供应商和研究项目分开。",
  "ja": "中国市場は完成機メーカーだけでなく、モーター、減速機、電池、ハンド、センサー、データ、製造能力で成り立ちます。完成機、インテグレーター、部品企業、研究プロジェクトを分けて掲載します。",
  "fr": "Les fiches Unitree G1 et UBTECH Walker S et les dossiers consacrés aux fabricants et aux prix sont accessibles ci-dessous.",
  "de": "Diese Übersicht führt zu den deutschsprachigen Profilen von Unitree G1 und UBTECH Walker S sowie zu den bestehenden Länderthemen."
},
    "facts": [
      {
        "label": {
          "zh-cn": "主要企业",
          "ja": "主な企業",
          "fr": "Entreprises citées",
          "de": "Genannte Unternehmen"
        },
        "value": {
          "zh-cn": "Unitree、优必选、智元机器人、傅利叶智能",
          "ja": "Unitree、UBTECH、AgiBot、Fourier Intelligence",
          "fr": "Unitree, UBTECH, AgiBot et Fourier Intelligence",
          "de": "Unitree, UBTECH, AgiBot und Fourier Intelligence"
        }
      },
      {
        "label": {
          "zh-cn": "比较口径",
          "ja": "比較方法",
          "fr": "Méthode de comparaison",
          "de": "Vergleichsmethode"
        },
        "value": {
          "zh-cn": "整机、零部件、研究平台和历史项目分别统计",
          "ja": "完成機、部品、研究プラットフォーム、歴史的プロジェクトを分離",
          "fr": "Robots complets, composants, plateformes de recherche et programmes historiques séparés",
          "de": "Komplettroboter, Komponenten, Forschungsplattformen und historische Programme getrennt"
        }
      },
      {
        "label": {
          "zh-cn": "证据标准",
          "ja": "証拠の基準",
          "fr": "Niveau de preuve",
          "de": "Nachweisstandard"
        },
        "value": {
          "zh-cn": "本地价格、出口价格、订单和实际交付不能混用",
          "ja": "国内価格、輸出価格、受注、実納入を混同しない",
          "fr": "Prix local, prix export, commande et livraison ne sont pas équivalents",
          "de": "Inlandspreis, Exportpreis, Auftrag und Auslieferung sind nicht gleichzusetzen"
        }
      }
    ],
    "related": [
      "china-companies-directory",
      "china-companies-article",
      "china-prices",
      "china-usa"
    ]
  ,
"editorialByLocale": {
  "de": {
    "pageType": "website",
    "facts": [],
    "sections": [],
    "hideEvidence": true,
    "related": [
      "unitree-g1",
      "ubtech-walker-s",
      "china-prices",
      "china-companies-article"
    ],
    "modified": "2026-09-29",
    "independentEdition": true,
    "labels": {
      "englishOriginal": "Englische Themenseite"
    }
  },
  "fr": {
    "modified": "2026-09-29",
    "independentEdition": true,
    "facts": [],
    "sections": [],
    "hideEvidence": true,
    "labels": {
      "englishOriginal": "Page en anglais",
      "verifiedFacts": "Données publiées",
      "evidence": "Sources et méthode"
    },
    "pageType": "website",
    "related": [
      "unitree-g1",
      "ubtech-walker-s",
      "china-companies-article",
      "china-prices"
    ]
  }
}
},
  {
  "key": "china-companies-directory",
  "basePath": "/robotics-companies/country/china",
  "pageType": "website",
  "method": "company",
  "modified": "2026-09-30",
  "keywordKeys": [
    "china",
    "companies",
    "humanoid",
    "industrial",
    "supply",
    "robotics"
  ],
  "subject": {
    "zh-cn": "中国机器人企业：相关中文资料",
    "ja": "中国のロボット企業：日本語の関連資料",
    "fr": "Entreprises robotiques chinoises : dossiers disponibles",
    "de": "Chinesische Unternehmen und Modellprofile"
  },
  "title": {
    "zh-cn": "中国机器人企业：相关中文资料",
    "ja": "中国のロボット企業：日本語の関連資料",
    "fr": "Entreprises robotiques chinoises : dossiers disponibles",
    "de": "Chinesische Robotikunternehmen Deutschsprachige Links"
  },
  "description": {
    "zh-cn": "通往 Unitree G1、UBTECH Walker S 和中国人形机器人主题的中文链接。",
    "ja": "Unitree G1、UBTECH Walker S、中国ヒューマノイド企業の日本語資料へのリンク。",
    "fr": "Liens vers les dossiers français sur les entreprises, les modèles et les prix des humanoïdes chinois.",
    "de": "Links zu TechniaHQ-Profilen chinesischer Humanoide und zur englischen Firmenliste. Die deutsche Seite enthält keine eigene Tabelle mit Unternehmenseinträgen."
  },
  "lead": {
    "zh-cn": "下方提供相关中文机器人和企业主题链接。此页没有独立的公司记录表；更完整的企业目录在英文页面。",
    "ja": "下記は日本語の機種紹介と企業関連ページです。このページに独立した企業一覧表はなく、詳しい企業ディレクトリは英語ページにあります。",
    "fr": "Les dossiers ci-dessous traitent des entreprises et robots humanoïdes chinois, de leurs modèles et de leurs prix.",
    "de": "Die ausführlichere Firmenliste ist über die englische Themenseite erreichbar. Die folgenden deutschen Links führen zu den Modellprofilen von Unitree und UBTECH sowie zu bestehenden China-Themen."
  },
  "facts": [
    {
      "label": {
        "zh-cn": "目录记录",
        "ja": "ディレクトリ登録",
        "fr": "Entrées du répertoire",
        "de": "Verzeichniseinträge"
      },
      "value": {
        "zh-cn": "当前目录中有6家中国企业记录",
        "ja": "現在6社の中国企業を登録",
        "fr": "6 entreprises chinoises actuellement répertoriées",
        "de": "Derzeit 6 chinesische Unternehmen erfasst"
      }
    },
    {
      "label": {
        "zh-cn": "覆盖范围",
        "ja": "対象範囲",
        "fr": "Périmètre",
        "de": "Abdeckung"
      },
      "value": {
        "zh-cn": "总部、产品、类别、行业、官网和来源",
        "ja": "本社、製品、分類、業界、公式サイト、出典",
        "fr": "Siège, produits, catégories, secteurs, site officiel et sources",
        "de": "Sitz, Produkte, Kategorien, Branchen, Website und Quellen"
      }
    },
    {
      "label": {
        "zh-cn": "证据标准",
        "ja": "証拠の基準",
        "fr": "Niveau de preuve",
        "de": "Nachweisstandard"
      },
      "value": {
        "zh-cn": "不把经销商、实验室和整机制造商混为一类",
        "ja": "販売代理店、研究所、完成機メーカーを混同しない",
        "fr": "Distributeurs, laboratoires et fabricants ne sont pas confondus",
        "de": "Händler, Labore und Hersteller werden nicht gleichgesetzt"
      }
    }
  ],
  "related": [
    "china-humanoids",
    "china-companies-article",
    "china-prices",
    "home"
  ],
  "editorialByLocale": {
    "de": {
      "facts": [],
      "sections": [],
      "hideEvidence": true,
      "related": [
        "unitree-g1",
        "ubtech-walker-s",
        "china-companies-article",
        "china-humanoids"
      ],
      "modified": "2026-09-29",
      "independentEdition": true,
      "labels": {
        "englishOriginal": "Englische Themenseite"
      }
    },
    "fr": {
      "modified": "2026-09-29",
      "independentEdition": true,
      "facts": [],
      "sections": [],
      "hideEvidence": true,
      "labels": {
        "englishOriginal": "Page en anglais",
        "verifiedFacts": "Données publiées",
        "evidence": "Sources et méthode"
      },
      "related": [
        "china-companies-article",
        "china-humanoids",
        "china-prices"
      ]
    },
    "zh-cn": {
      "independentEdition": true,
      "labels": {
        "englishOriginal": "英文页面",
        "verifiedFacts": "阅读要点"
      },
      "hideEvidence": true,
      "facts": []
    },
    "ja": {
      "independentEdition": true,
      "labels": {
        "englishOriginal": "英語ページ",
        "verifiedFacts": "確認項目"
      },
      "hideEvidence": true,
      "facts": []
    }
  }
},
  {
  "key": "china-companies-article",
  "basePath": "/robotics-news/china-humanoid-robot-companies",
  "pageType": "article",
  "method": "article",
  "modified": "2026-09-30",
  "keywordKeys": [
    "china",
    "humanoid",
    "companies",
    "supply",
    "prices",
    "embodiedAI"
  ],
  "subject": {
    "zh-cn": "中国人形机器人企业：阅读制造商资料",
    "ja": "中国ヒューマノイド企業：メーカー資料の読み方",
    "fr": "Entreprises humanoïdes chinoises lire les sources des fabricants",
    "de": "Chinesische Humanoid-Unternehmen Herstellerangaben einordnen"
  },
  "title": {
    "zh-cn": "中国人形机器人企业：阅读制造商资料",
    "ja": "中国ヒューマノイド企業：メーカー資料の読み方",
    "fr": "Entreprises humanoïdes chinoises lire les sources des fabricants",
    "de": "Chinesische Humanoid-Unternehmen Herstellerangaben einordnen"
  },
  "description": {
    "zh-cn": "Unitree、AgiBot 和 UBTECH 官方入口，以及核对机器人制造商、部件供应商、型号和交付口径的字段。",
    "ja": "Unitree、AgiBot、UBTECHの公式入口と、製造元、部品供給者、機種、納入の定義を確認する項目。",
    "fr": "Liens Unitree, AgiBot et UBTECH et critères pour distinguer fabricant de robots, fournisseur de composants, objectif et livraison.",
    "de": "Links zu Unitree, AgiBot und UBTECH sowie Prüfkriterien für Robotermodelle, Komponenten, Produktionsziele und Lieferungen."
  },
  "lead": {
    "zh-cn": "阅读企业公告时，分别记录机器人型号、整机制造商、部件供应商、生产目标和已交付数量。下方提供官方入口；本页未完成供应链地图或交付统计。",
    "ja": "企業発表を読む際は、機種、完成機メーカー、部品供給者、生産目標、納入台数を分けて記録します。下記は公式資料への入口であり、供給網マップや納入集計ではありません。",
    "fr": "Les liens ci-dessous renvoient aux sites de Unitree, AgiBot et UBTECH. Pour lire leurs annonces, relever le modèle concerné et distinguer fabricant du robot, fournisseur de composants, objectif de production et unités livrées.",
    "de": "Die folgenden Links führen zu Unitree, AgiBot und UBTECH. Beim Lesen einer Meldung sind das konkrete Modell, der Hersteller des Roboters, die Komponentenlieferanten sowie Produktionsziel und ausgelieferte Einheiten getrennt zu erfassen."
  },
  "facts": [
    {
      "label": {
        "zh-cn": "主要企业",
        "ja": "主な企業",
        "fr": "Entreprises citées",
        "de": "Genannte Unternehmen"
      },
      "value": {
        "zh-cn": "Unitree、优必选、智元机器人、傅利叶智能",
        "ja": "Unitree、UBTECH、AgiBot、Fourier Intelligence",
        "fr": "Unitree, UBTECH, AgiBot et Fourier Intelligence",
        "de": "Unitree, UBTECH, AgiBot und Fourier Intelligence"
      }
    },
    {
      "label": {
        "zh-cn": "证据标准",
        "ja": "証拠の基準",
        "fr": "Niveau de preuve",
        "de": "Nachweisstandard"
      },
      "value": {
        "zh-cn": "官方产品、公司声明、真实硬件证据和缺失数据分级",
        "ja": "公式製品、企業発表、実機証拠、欠損データを分類",
        "fr": "Produits officiels, déclarations, preuves matérielles et données manquantes classés",
        "de": "Offizielle Produkte, Firmenangaben, Hardware-Nachweise und fehlende Daten klassifiziert"
      }
    },
    {
      "label": {
        "zh-cn": "状态",
        "ja": "状態",
        "fr": "Statut",
        "de": "Status"
      },
      "value": {
        "zh-cn": "没有统一审计的出货数据库",
        "ja": "統一監査された出荷データベースは存在しない",
        "fr": "Aucune base auditée unique ne couvre toutes les livraisons",
        "de": "Keine einheitlich auditierte Lieferdatenbank verfügbar"
      }
    }
  ],
  "related": [
    "china-humanoids",
    "china-companies-directory",
    "china-prices",
    "china-usa"
  ],
  "sourceLinks": [
    {
      "label": "Unitree G1",
      "url": "https://www.unitree.com/g1/"
    },
    {
      "label": "AgiBot",
      "url": "https://www.agibot.com/"
    },
    {
      "label": "UBTECH Walker S2",
      "url": "https://www.ubtrobot.com/en/humanoid/products/walker-s2"
    }
  ],
  "editorialByLocale": {
    "fr": {
      "independentEdition": true,
      "labels": {
        "englishOriginal": "Page en anglais",
        "verifiedFacts": "Repères de lecture"
      },
      "methodText": "Les liens donnent accès aux documents des fabricants. Aucun décompte de livraisons ni classement de performances n’a été calculé pour cette page.",
      "facts": [
        {
          "label": {
            "fr": "Entreprises citées"
          },
          "value": {
            "fr": "Unitree, UBTECH, AgiBot et Fourier Intelligence"
          }
        }
      ]
    },
    "de": {
      "independentEdition": true,
      "labels": {
        "englishOriginal": "Seite auf Englisch",
        "verifiedFacts": "Kriterien zum Lesen"
      },
      "methodText": "Die Links führen zu Herstellerdokumenten. Für diese Seite wurden keine Lieferzahlen berechnet und keine Leistungsrangliste erstellt.",
      "facts": [
        {
          "label": {
            "de": "Genannte Unternehmen"
          },
          "value": {
            "de": "Unitree, UBTECH, AgiBot und Fourier Intelligence"
          }
        }
      ]
    },
    "zh-cn": {
      "independentEdition": true,
      "labels": {
        "englishOriginal": "英文页面",
        "verifiedFacts": "阅读要点"
      },
      "methodText": "下方链接提供官方资料。本页给出阅读字段，未计算交付总数或性能排名。",
      "facts": [
        {
          "label": {
            "zh-cn": "资料入口"
          },
          "value": {
            "zh-cn": "Unitree、AgiBot、UBTECH"
          }
        }
      ]
    },
    "ja": {
      "independentEdition": true,
      "labels": {
        "englishOriginal": "英語ページ",
        "verifiedFacts": "確認項目"
      },
      "methodText": "下記は公式資料へのリンクです。本ページは確認項目を示すもので、納入合計や性能順位は算出していません。",
      "facts": [
        {
          "label": {
            "ja": "資料の入口"
          },
          "value": {
            "ja": "Unitree、AgiBot、UBTECH"
          }
        }
      ]
    }
  }
},
  {
  "key": "china-prices",
  "basePath": "/robotics-news/chinese-humanoid-robot-prices",
  "pageType": "article",
  "method": "article",
  "modified": "2026-09-30",
  "keywordKeys": [
    "prices",
    "china",
    "humanoid",
    "companies",
    "supply",
    "robotics"
  ],
  "subject": {
    "zh-cn": "中国人形机器人报价：需要核对的条件",
    "ja": "中国製ヒューマノイドの見積もり：確認する条件",
    "fr": "Prix des humanoïdes chinois lire le contenu des offres",
    "de": "Preise chinesischer Humanoide Angebote richtig lesen"
  },
  "title": {
    "zh-cn": "中国人形机器人报价：需要核对的条件",
    "ja": "中国製ヒューマノイドの見積もり：確認する条件",
    "fr": "Prix des humanoïdes chinois lire le contenu des offres",
    "de": "Preise chinesischer Humanoide Angebote richtig lesen"
  },
  "description": {
    "zh-cn": "通过 Unitree 和 Booster Robotics 官方入口核对型号、配置、币种、税费、运输及软件条件。",
    "ja": "UnitreeとBooster Roboticsの公式入口から、機種、構成、通貨、税、送料、ソフトウェア条件を確認するための項目。",
    "fr": "Critères de lecture des offres Unitree et Booster Robotics selon le modèle, la configuration, les taxes, le transport et les logiciels.",
    "de": "Prüfkriterien für Angebote von Unitree und Booster Robotics mit Modell, Konfiguration, Steuern, Versand und Softwareumfang."
  },
  "lead": {
    "zh-cn": "比较报价前，先记录完整型号、配置、币种、税费、运输和软件内容。下方链接用于查找这些条件；本页没有按日期整理的价格表。",
    "ja": "見積もり比較の前に機種、構成、通貨、税、送料、ソフトウェア内容を記録します。下記のリンクは条件確認用で、本ページには日付付き価格表はありません。",
    "fr": "Avant de comparer deux offres, relever le modèle, la configuration, la devise, les taxes, le transport et l’accès logiciel. Les liens constructeur ci-dessous servent à rechercher ces conditions ; cette page ne présente pas de tableau de prix datés.",
    "de": "Vor einem Preisvergleich müssen Modell, Konfiguration, Währung, Steuern, Versand und Softwareumfang feststehen. Die Herstellerlinks dienen dazu, diese Bedingungen zu prüfen. Eine datierte Preistabelle enthält diese Seite nicht."
  },
  "facts": [
    {
      "label": {
        "zh-cn": "比较口径",
        "ja": "比較方法",
        "fr": "Méthode de comparaison",
        "de": "Vergleichsmethode"
      },
      "value": {
        "zh-cn": "公开起售价、询价、预订和研究套件分别处理",
        "ja": "公開開始価格、要見積もり、予約、研究キットを分離",
        "fr": "Prix de départ, devis, précommande et kit de recherche séparés",
        "de": "Startpreis, Angebot, Vorbestellung und Forschungskit getrennt"
      }
    },
    {
      "label": {
        "zh-cn": "公开价格",
        "ja": "公開価格",
        "fr": "Prix public",
        "de": "Öffentlicher Preis"
      },
      "value": {
        "zh-cn": "不使用未标明配置的二手转述价格",
        "ja": "構成不明の転載価格は使用しない",
        "fr": "Aucun prix repris sans configuration identifiable",
        "de": "Keine übernommenen Preise ohne erkennbare Konfiguration"
      }
    },
    {
      "label": {
        "zh-cn": "证据标准",
        "ja": "証拠の基準",
        "fr": "Niveau de preuve",
        "de": "Nachweisstandard"
      },
      "value": {
        "zh-cn": "订单金额不等于已付款和已交付数量",
        "ja": "受注額は支払い済み・納入済み台数ではない",
        "fr": "La valeur d’une commande ne prouve ni paiement ni livraison",
        "de": "Auftragswert belegt weder Zahlung noch Auslieferung"
      }
    }
  ],
  "related": [
    "unitree-g1",
    "ubtech-walker-s",
    "china-companies-article",
    "china-usa"
  ],
  "sourceLinks": [
    {
      "label": "Unitree G1",
      "url": "https://www.unitree.com/g1/"
    },
    {
      "label": "Unitree R1",
      "url": "https://www.unitree.com/R1"
    },
    {
      "label": "Booster Robotics",
      "url": "https://www.boosterobotics.com/"
    }
  ],
  "editorialByLocale": {
    "fr": {
      "independentEdition": true,
      "labels": {
        "englishOriginal": "Page en anglais",
        "verifiedFacts": "Repères de lecture"
      },
      "methodText": "Les liens donnent accès aux documents des fabricants. Aucun décompte de livraisons ni classement de performances n’a été calculé pour cette page.",
      "facts": [
        {
          "label": {
            "fr": "À relever dans l’offre"
          },
          "value": {
            "fr": "Modèle exact, configuration, devise, taxes, transport et logiciels"
          }
        },
        {
          "label": {
            "fr": "Type d’offre"
          },
          "value": {
            "fr": "Prix de départ, devis, précommande ou kit de recherche"
          }
        }
      ]
    },
    "de": {
      "independentEdition": true,
      "labels": {
        "englishOriginal": "Seite auf Englisch",
        "verifiedFacts": "Kriterien zum Lesen"
      },
      "methodText": "Die Links führen zu Herstellerdokumenten. Für diese Seite wurden keine Lieferzahlen berechnet und keine Leistungsrangliste erstellt.",
      "facts": [
        {
          "label": {
            "de": "Im Angebot zu erfassen"
          },
          "value": {
            "de": "Genaues Modell, Konfiguration, Währung, Steuern, Versand und Software"
          }
        },
        {
          "label": {
            "de": "Art des Angebots"
          },
          "value": {
            "de": "Startpreis, individuelles Angebot, Vorbestellung oder Forschungskit"
          }
        }
      ]
    },
    "zh-cn": {
      "independentEdition": true,
      "labels": {
        "englishOriginal": "英文页面",
        "verifiedFacts": "阅读要点"
      },
      "methodText": "下方链接提供官方资料。本页给出阅读字段，未计算交付总数或性能排名。",
      "facts": [
        {
          "label": {
            "zh-cn": "核对字段"
          },
          "value": {
            "zh-cn": "型号、配置、币种、税费、运输、软件"
          }
        }
      ]
    },
    "ja": {
      "independentEdition": true,
      "labels": {
        "englishOriginal": "英語ページ",
        "verifiedFacts": "確認項目"
      },
      "methodText": "下記は公式資料へのリンクです。本ページは確認項目を示すもので、納入合計や性能順位は算出していません。",
      "facts": [
        {
          "label": {
            "ja": "確認する項目"
          },
          "value": {
            "ja": "機種、構成、通貨、税、送料、ソフトウェア"
          }
        }
      ]
    }
  }
},
  {
  "key": "china-usa",
  "basePath": "/robotics-news/china-vs-usa-humanoid-robot-production",
  "pageType": "article",
  "method": "article",
  "modified": "2026-08-04",
  "keywordKeys": [
    "china",
    "humanoid",
    "automation",
    "companies",
    "supply",
    "industrial"
  ],
  "subject": {
    "zh-cn": "中美人形机器人生产公告：区分统计口径",
    "ja": "中国・米国のヒューマノイド生産発表：指標の区別",
    "fr": "Production humanoïde en Chine et aux États-Unis lire les annonces",
    "de": "Humanoid-Produktion in China und den USA Meldungen einordnen"
  },
  "title": {
    "zh-cn": "中美人形机器人生产公告：区分统计口径",
    "ja": "中国・米国のヒューマノイド生産発表：指標の区別",
    "fr": "Production humanoïde en Chine et aux États-Unis lire les annonces",
    "de": "Humanoid-Produktion in China und den USA Meldungen einordnen"
  },
  "description": {
    "zh-cn": "区分生产目标、理论产能、完成机器、出货和客户运行，避免把不同指标当成同一结果。",
    "ja": "生産目標、理論能力、完成台数、出荷、顧客運用を区別して企業発表を読むための項目。",
    "fr": "Distinguer objectifs, capacité théorique, robots assemblés, expéditions et exploitation chez le client dans les annonces de production.",
    "de": "Produktionsziele, theoretische Kapazität, montierte Roboter, Versand und Kundeneinsatz in Unternehmensmeldungen unterscheiden."
  },
  "lead": {
    "zh-cn": "生产目标、理论产能、完成数量、出货和客户长期运行不是同一指标。比较中美企业公告前，需要相同定义和统计期间。本页没有计算两国的产量或交付总数。",
    "ja": "生産目標、理論能力、完成台数、出荷、顧客での継続運用は別の指標です。中国と米国の発表を比較するには定義と期間をそろえる必要があります。本ページでは国別合計を算出していません。",
    "fr": "Objectif annuel, capacité théorique, robots assemblés, expéditions et exploitation chez un client désignent des mesures différentes. Pour comparer des annonces chinoises et américaines, relever la définition et la période de chaque nombre. Aucun total comparatif par pays n’est établi sur cette page.",
    "de": "Jahresziel, theoretische Kapazität, montierte Roboter, Versand und Kundeneinsatz sind unterschiedliche Kennzahlen. Für einen Vergleich chinesischer und amerikanischer Meldungen müssen Definition und Zeitraum übereinstimmen. Diese Seite enthält keine berechneten Ländersummen."
  },
  "facts": [
    {
      "label": {
        "zh-cn": "比较口径",
        "ja": "比較方法",
        "fr": "Méthode de comparaison",
        "de": "Vergleichsmethode"
      },
      "value": {
        "zh-cn": "生产目标、安装产能、完成机器、出货和部署分别统计",
        "ja": "目標、設備能力、完成機、出荷、導入を別々に集計",
        "fr": "Objectif, capacité, robots terminés, expéditions et déploiements séparés",
        "de": "Ziel, Kapazität, fertige Geräte, Versand und Einsatz getrennt"
      }
    },
    {
      "label": {
        "zh-cn": "证据标准",
        "ja": "証拠の基準",
        "fr": "Niveau de preuve",
        "de": "Nachweisstandard"
      },
      "value": {
        "zh-cn": "公司数字保留其报告范围和日期",
        "ja": "企業数値の対象範囲と日付を保持",
        "fr": "Périmètre et date de chaque chiffre conservés",
        "de": "Umfang und Datum jeder Firmenzahl bleiben erhalten"
      }
    },
    {
      "label": {
        "zh-cn": "状态",
        "ja": "状態",
        "fr": "Statut",
        "de": "Status"
      },
      "value": {
        "zh-cn": "不同任务和工厂不能直接形成性能排名",
        "ja": "異なる作業・工場を単純ランキングしない",
        "fr": "Des tâches et usines différentes ne forment pas un classement fiable",
        "de": "Unterschiedliche Aufgaben und Fabriken ergeben kein belastbares Ranking"
      }
    }
  ],
  "related": [
    "china-humanoids",
    "china-companies-article",
    "china-prices",
    "humanoid"
  ],
  "sourceLinks": [
    {
      "label": "Agility Robotics — RoboFab",
      "url": "https://www.agilityrobotics.com/company"
    },
    {
      "label": "1X — NEO Factory",
      "url": "https://www.1x.tech/discover/neo-factory"
    },
    {
      "label": "Tesla AI and Robotics",
      "url": "https://www.tesla.com/AI"
    }
  ],
  "editorialByLocale": {
    "fr": {
      "independentEdition": true,
      "labels": {
        "englishOriginal": "Page en anglais",
        "verifiedFacts": "Repères de lecture"
      },
      "methodText": "Les liens donnent accès aux documents des fabricants. Aucun décompte de livraisons ni classement de performances n’a été calculé pour cette page.",
      "facts": [
        {
          "label": {
            "fr": "Définition"
          },
          "value": {
            "fr": "Objectif, capacité, robots assemblés, expéditions ou déploiements"
          }
        },
        {
          "label": {
            "fr": "Périmètre"
          },
          "value": {
            "fr": "Période, modèle concerné et conditions de comptage"
          }
        }
      ]
    },
    "de": {
      "independentEdition": true,
      "labels": {
        "englishOriginal": "Seite auf Englisch",
        "verifiedFacts": "Kriterien zum Lesen"
      },
      "methodText": "Die Links führen zu Herstellerdokumenten. Für diese Seite wurden keine Lieferzahlen berechnet und keine Leistungsrangliste erstellt.",
      "facts": [
        {
          "label": {
            "de": "Definition"
          },
          "value": {
            "de": "Ziel, Kapazität, montierte Roboter, Versand oder Kundeneinsatz"
          }
        },
        {
          "label": {
            "de": "Umfang"
          },
          "value": {
            "de": "Zeitraum, Robotermodell und Zählweise"
          }
        }
      ]
    },
    "zh-cn": {
      "independentEdition": true,
      "labels": {
        "englishOriginal": "英文页面",
        "verifiedFacts": "阅读要点"
      },
      "methodText": "下方链接提供官方资料。本页给出阅读字段，未计算交付总数或性能排名。",
      "facts": [
        {
          "label": {
            "zh-cn": "核对字段"
          },
          "value": {
            "zh-cn": "统计定义、期间、型号、工厂与客户部署范围"
          }
        }
      ]
    },
    "ja": {
      "independentEdition": true,
      "labels": {
        "englishOriginal": "英語ページ",
        "verifiedFacts": "確認項目"
      },
      "methodText": "下記は公式資料へのリンクです。本ページは確認項目を示すもので、納入合計や性能順位は算出していません。",
      "facts": [
        {
          "label": {
            "ja": "確認する項目"
          },
          "value": {
            "ja": "集計定義、期間、機種、工場と顧客導入の範囲"
          }
        }
      ]
    }
  }
},
  {
    "key": "unitree-g1",
    "basePath": "/humanoid-robots/unitree-g1",
    "pageType": "website",
    "method": "robot",
    "modified": "2026-09-30",
    "keywordKeys": [
      "humanoid",
      "china",
      "prices",
      "wholeBody",
      "robotLearning",
      "physicalAI"
    ],
    "subject": {
  "zh-cn": "Unitree G1 人形机器人",
  "ja": "Unitree G1 ヒューマノイド",
  "fr": "Unitree G1 : que changent les options du G1 EDU ?",
  "de": "Unitree G1 Humanoid-Roboter"
},
    "title": {
  "zh-cn": "Unitree G1：价格、规格、传感器与开发版本",
  "ja": "Unitree G1：価格、仕様、センサー、開発版",
  "fr": "Unitree G1 : que changent les options du G1 EDU ?",
  "de": "Unitree G1 Was 23, 29 und 43 Freiheitsgrade bedeuten"
},
    "description": {
  "zh-cn": "Unitree G1 官方规格核对：13,500美元起、约35千克、23至43自由度、深度相机、3D LiDAR、约2小时续航、G1与G1 EDU差异及二次开发状态。",
  "ja": "Unitree G1の公式仕様を整理。13,500米ドルからの価格、約35kgの重量、23～43自由度、深度カメラ、3D LiDAR、約2時間のバッテリーを確認できます。標準G1とG1 EDUの構成差、開発用途、公開仕様の範囲、購入時に確認すべき地域価格やオプションを出典付きでまとめ、最近の確認日も示します。",
  "fr": "Comparaison des articulations G1 et G1 EDU, des mains optionnelles et des limites de charge publiées par Unitree.",
  "de": "G1 und G1 EDU anhand des Datenblatts und des Unitree-SDK verglichen. Welche Gelenke und Hände gezählt werden und was das Armbeispiel tatsächlich steuert."
},
    "lead": {
  "zh-cn": "Unitree G1 是一款紧凑型人形机器人。官方产品页明确区分标准 G1 和 G1 EDU：标准版记录 23 个关节自由度，而 EDU 根据配置可达到 23 至 43 个，并支持二次开发。页面只采用 Unitree 发布的配置，不把改装机或比赛版本能力归到标准 G1。",
  "ja": "Unitree G1は小型ヒューマノイドです。公式ページは標準G1とG1 EDUを分け、標準は23自由度、EDUは構成により23～43自由度で二次開発に対応します。改造機や競技版の性能は標準G1の仕様として扱いません。",
  "fr": "Le G1 standard compte 23 degrés de liberté. Le G1 EDU peut en compter jusqu’à 43 selon les options ; ce maximum ne décrit pas le robot de base.",
  "de": "Der G1 ist ein kompakter Humanoid. Unitree trennt den Standard-G1 mit 23 Freiheitsgraden vom G1 EDU, der je nach Konfiguration 23 bis 43 Freiheitsgrade und Secondary Development unterstützt. Fähigkeiten modifizierter oder wettkampfspezifischer Varianten werden nicht dem Standardmodell zugerechnet."
},
    "facts": [
      {
        "label": {
          "zh-cn": "公开价格",
          "ja": "公開価格",
          "fr": "Prix public",
          "de": "Öffentlicher Preis"
        },
        "value": {
          "zh-cn": "标准 G1 起价 13,500 美元，不含税费和运输；G1 EDU 需联系销售",
          "ja": "標準G1は13,500米ドルから（税・送料別）。G1 EDUは要問い合わせ",
          "fr": "G1 standard à partir de 13 500 $, hors taxes et transport ; G1 EDU sur devis",
          "de": "Standard-G1 ab 13.500 US-Dollar ohne Steuern und Versand; G1 EDU auf Anfrage"
        }
      },
      {
        "label": {
          "zh-cn": "尺寸与重量",
          "ja": "寸法・重量",
          "fr": "Dimensions et poids",
          "de": "Abmessungen und Gewicht"
        },
        "value": {
          "zh-cn": "站立 1320×450×200 mm；含电池约35 kg",
          "ja": "立位1320×450×200 mm、バッテリー込み約35 kg",
          "fr": "1320 × 450 × 200 mm debout ; environ 35 kg avec batterie",
          "de": "1320 × 450 × 200 mm stehend; etwa 35 kg mit Akku"
        }
      },
      {
        "label": {
          "zh-cn": "自由度",
          "ja": "自由度",
          "fr": "Degrés de liberté",
          "de": "Freiheitsgrade"
        },
        "value": {
          "zh-cn": "G1：23；G1 EDU：23–43，取决于配置",
          "ja": "G1：23、G1 EDU：構成により23～43",
          "fr": "G1  23 ; G1 EDU  23 à 43 selon la configuration",
          "de": "G1 23; G1 EDU je nach Konfiguration 23–43"
        }
      },
      {
        "label": {
          "zh-cn": "感知",
          "ja": "センサー",
          "fr": "Perception",
          "de": "Sensorik"
        },
        "value": {
          "zh-cn": "深度相机 + 3D LiDAR；4麦克风阵列",
          "ja": "深度カメラ + 3D LiDAR、4マイクアレイ",
          "fr": "Caméra de profondeur + LiDAR 3D ; réseau de 4 microphones",
          "de": "Tiefenkamera + 3D-LiDAR; 4-Mikrofon-Array"
        }
      },
      {
        "label": {
          "zh-cn": "电池与续航",
          "ja": "バッテリー",
          "fr": "Batterie",
          "de": "Akku"
        },
        "value": {
          "zh-cn": "9000 mAh 快拆电池；官方标注约2小时",
          "ja": "9000 mAhクイックリリース、公式値は約2時間",
          "fr": "Batterie amovible 9000 mAh ; environ 2 h annoncées",
          "de": "9000-mAh-Schnellwechselakku; Herstellerangabe ca. 2 Stunden"
        }
      },
      {
        "label": {
          "zh-cn": "开发状态",
          "ja": "開発対応",
          "fr": "Développement",
          "de": "Entwicklung"
        },
        "value": {
          "zh-cn": "标准 G1 官方表格不标注二次开发；G1 EDU 标注支持二次开发",
          "ja": "標準G1は二次開発なし表記、G1 EDUは対応",
          "fr": "Le tableau officiel n'indique pas le développement secondaire pour le G1 standard ; le G1 EDU le prend en charge",
          "de": "Im offiziellen Datenblatt ist Secondary Development für den Standard-G1 nicht angegeben; G1 EDU unterstützt es"
        }
      }
    ],
    "sections": [
      {
        "heading": {
          "zh-cn": "标准 G1 与 G1 EDU 不是同一配置",
          "ja": "標準G1とG1 EDUは同一仕様ではない",
          "fr": "G1 standard et G1 EDU ne sont pas la même configuration",
          "de": "Standard-G1 und G1 EDU sind nicht identisch ausgestattet"
        },
        "body": {
          "zh-cn": "两款机器人外形尺寸接近，但 EDU 版本可以增加腰部、手腕和灵巧手自由度，并提供更高计算模块选项。比较价格或自由度时必须写明版本。",
          "ja": "外形寸法は近い一方、EDUは腰・手首・ハンドの自由度追加や高演算モジュールの選択肢があります。価格やDoFを比較する際は版を明記する必要があります。",
          "fr": "Les dimensions sont proches, mais l'EDU peut ajouter des DoF à la taille, aux poignets et aux mains et recevoir des modules de calcul plus puissants. Toute comparaison de prix ou de DoF doit donc préciser la version.",
          "de": "Die Abmessungen sind ähnlich, doch EDU kann zusätzliche Freiheitsgrade an Taille, Handgelenken und Händen sowie leistungsfähigere Rechenmodule erhalten. Preis- und DoF-Vergleiche müssen deshalb die Variante nennen."
        }
      },
      {
        "heading": {
          "zh-cn": "传感器不等于自主能力",
          "ja": "センサー搭載は自律性の証明ではない",
          "fr": "Les capteurs ne prouvent pas l'autonomie",
          "de": "Sensoren belegen keine Autonomie"
        },
        "body": {
          "zh-cn": "官方规格列出深度相机和 3D LiDAR，但这只说明硬件存在。具体任务是否依赖遥控、外部定位、预编程动作或机载感知，需要按演示或软件版本分别验证。",
          "ja": "公式仕様には深度カメラと3D LiDARがありますが、搭載だけで自律性は証明できません。遠隔操作、外部測位、事前動作、オンボード認識への依存はデモやソフトウェア版ごとに確認が必要です。",
          "fr": "La fiche mentionne une caméra de profondeur et un LiDAR 3D, mais leur présence ne démontre pas une tâche autonome. Téléopération, localisation externe, mouvements préprogrammés et perception embarquée doivent être vérifiés pour chaque démonstration.",
          "de": "Tiefenkamera und 3D-LiDAR sind Hardwaremerkmale, kein Nachweis autonomer Aufgaben. Teleoperation, externe Ortung, vorprogrammierte Bewegungen und Onboard-Perception müssen pro Demo oder Softwarestand geprüft werden."
        }
      },
      {
        "heading": {
          "zh-cn": "购买前先核对配置和限制",
          "ja": "購入前に構成と制限を確認",
          "fr": "Vérifier la configuration avant l'achat",
          "de": "Konfiguration vor dem Kauf prüfen"
        },
        "body": {
          "zh-cn": "Unitree 提醒不同场景和配置下参数可能变化，并建议个人用户充分了解人形机器人的限制。购买时应确认具体手型、计算模块、开发权限、保修、税费和运输。",
          "ja": "Unitreeは構成や条件で数値が変わる可能性を明記し、個人購入者にヒューマノイドの制限理解を推奨しています。ハンド、計算モジュール、開発権限、保証、税・送料を確認すべきです。",
          "fr": "Unitree indique que les paramètres peuvent varier selon la configuration et recommande aux particuliers de comprendre les limites des humanoïdes. Il faut confirmer mains, calcul embarqué, accès développement, garantie, taxes et transport.",
          "de": "Unitree weist darauf hin, dass Werte je nach Konfiguration variieren können, und empfiehlt Privatkunden, die Grenzen humanoider Roboter zu verstehen. Handoptionen, Rechenmodul, Entwicklungszugang, Garantie, Steuern und Versand sollten vor dem Kauf geklärt werden."
        }
      }
    ],
    "sourceLinks": [
      {
        "label": {
          "zh-cn": "Unitree G1 官方产品页",
          "ja": "Unitree G1公式製品ページ",
          "fr": "Page produit officielle Unitree G1",
          "de": "Offizielle Unitree-G1-Produktseite"
        },
        "url": "https://www.unitree.com/g1/"
      },
      {
        "label": {
          "zh-cn": "Unitree G1 开发文档",
          "ja": "Unitree G1開発ドキュメント",
          "fr": "Documentation développeur Unitree G1",
          "de": "Unitree-G1-Entwicklerdokumentation"
        },
        "url": "https://support.unitree.com/home/en/G1_developer"
      }
    ],
    "related": [
      "humanoid",
      "china-prices",
      "ubtech-walker-s",
      "xiaomi"
    ]
  ,
"editorialByLocale": {
  "de": {
    "sections": [
      {
        "heading": {
          "de": "Die Gelenkzahlen lassen sich aufschlüsseln"
        },
        "body": {
          "de": "Der Standard-G1 hat laut Datenblatt zweimal sechs Beinachsen, eine Taillenachse und zweimal fünf Armachsen. Das ergibt 23. Mit zwei zusätzlichen Taillenachsen und je zwei zusätzlichen Handgelenkachsen sind es 29. Zwei optionale Dex3-1-Hände mit jeweils sieben aktiven Achsen ergeben zusammen 43. Diese Addition erklärt die unterschiedlichen Gesamtzahlen; sie beschreibt keine einheitliche Ausstattung jedes G1 EDU."
        }
      },
      {
        "heading": {
          "de": "Was im veröffentlichten Armbeispiel passiert"
        },
        "body": {
          "de": "Im SDK-Beispiel g1_dual_arm_example.cpp steht G1_NUM_MOTOR auf 29. Die Armindizes umfassen Schulter, Ellbogen und Handgelenk; Finger sind dort nicht enthalten. Das Programm lädt eine gespeicherte Bewegungsfolge aus motion.seq und sendet Gelenk-Sollwerte über rt/lowcmd. Es fordert zuvor die Freigabe des vorhandenen Bewegungsdienstes an. Die Lektüre belegt daher ein Beispiel für Gelenksteuerung und gespeicherte Armbewegungen. Eine kameragestützte Objektauswahl oder selbstständige Greifplanung ist in dieser Datei nicht implementiert."
        }
      },
      {
        "heading": {
          "de": "Welche Ausstattung für Manipulation fehlt"
        },
        "body": {
          "de": "Beim Standard-G1 nennt die Tabelle keine aktive Handoption. Die Dex3-1-Hand und taktile Sensorfelder sind EDU-Optionen. Auch ein leistungsfähigeres Rechenmodul ist gesondert aufgeführt. Die vorhandene Tiefenkamera und das 3D-LiDAR allein bestimmen daher nicht, welche Greifaufgabe eine konkrete Konfiguration ausführen kann."
        }
      }
    ],
    "sourceLinks": [
      {
        "label": "Unitree G1 und G1 EDU Datenblatt",
        "url": "https://www.unitree.com/g1/"
      },
      {
        "label": "Unitree SDK Armbeispiel, festgehaltene Codeversion",
        "url": "https://github.com/unitreerobotics/unitree_sdk2/blob/8fe9d6e191d3bfa13c99fe3eced8bcb05da8e542/example/g1/low_level/g1_dual_arm_example.cpp"
      },
      {
        "label": "Unitree Entwicklerdokumentation",
        "url": "https://support.unitree.com/home/en/G1_developer"
      }
    ],
    "methodText": "Preis, Hardware und Laufzeit stammen von Unitree. Die Gelenkaddition und der Ablauf des Armbeispiels wurden aus Datenblatt und veröffentlichtem Code nachvollzogen. Der Code wurde nicht auf einem Roboter ausgeführt.",
    "labels": {
      "englishOriginal": "Englische Themenseite",
      "verifiedFacts": "Veröffentlichte Ausstattung"
    },
    "modified": "2026-09-29",
    "independentEdition": true,
    "facts": [
      {
        "label": {
          "de": "Öffentlicher Preis"
        },
        "value": {
          "de": "Standard-G1 ab 13.500 US-Dollar ohne Steuern und Versand; G1 EDU auf Anfrage"
        }
      },
      {
        "label": {
          "de": "Abmessungen und Gewicht"
        },
        "value": {
          "de": "1320 × 450 × 200 mm stehend; G1 etwa 35 kg, EDU etwa 35 kg oder mehr, jeweils mit Akku"
        }
      },
      {
        "label": {
          "de": "Freiheitsgrade"
        },
        "value": {
          "de": "G1 23; G1 EDU je nach Konfiguration 23–43"
        }
      },
      {
        "label": {
          "de": "Sensorik"
        },
        "value": {
          "de": "Tiefenkamera + 3D-LiDAR; 4-Mikrofon-Array"
        }
      },
      {
        "label": {
          "de": "Akku"
        },
        "value": {
          "de": "9000-mAh-Schnellwechselakku; Herstellerangabe ca. 2 Stunden"
        }
      },
      {
        "label": {
          "de": "Entwicklung"
        },
        "value": {
          "de": "Im offiziellen Datenblatt ist Secondary Development für den Standard-G1 nicht angegeben; G1 EDU unterstützt es"
        }
      }
    ]
  },
  "fr": {
    "modified": "2026-09-29",
    "independentEdition": true,
    "facts": [
      {
        "label": {
          "fr": "Prix constructeur"
        },
        "value": {
          "fr": "G1 : 13 500 USD hors taxes et transport ; EDU : contacter les ventes"
        }
      },
      {
        "label": {
          "fr": "Dimensions et masse"
        },
        "value": {
          "fr": "1 320 × 450 × 200 mm ; environ 35 kg avec batterie pour le G1"
        }
      },
      {
        "label": {
          "fr": "Perception et alimentation"
        },
        "value": {
          "fr": "Caméra de profondeur, LiDAR 3D ; 9 000 mAh, environ 2 h annoncées"
        }
      }
    ],
    "sections": [
      {
        "heading": {
          "fr": "D’où viennent les 20 degrés de liberté supplémentaires ?"
        },
        "body": {
          "fr": "Le tableau Unitree donne 6 articulations par jambe, 5 par bras et 1 à la taille : 2 × 6 + 2 × 5 + 1 = 23. Les options EDU ajoutent 2 à la taille, puis, de chaque côté, 2 au poignet et 7 dans la main Dex3-1 : 23 + 2 + 2 × (2 + 7) = 43. C’est un calcul à partir des options publiées, pas une mesure de dextérité."
        }
      },
      {
        "heading": {
          "fr": "Charge et accès au développement"
        },
        "body": {
          "fr": "Unitree annonce environ 2 kg par bras pour le G1 et 3 kg pour l’EDU, mais précise que la charge varie fortement avec l’extension du bras. Ces maxima ne garantissent donc pas la même charge à toute portée. Le tableau réserve le développement secondaire à l’EDU."
        }
      }
    ],
    "hideEvidence": false,
    "labels": {
      "englishOriginal": "Page en anglais",
      "verifiedFacts": "Données publiées",
      "evidence": "Sources et méthode"
    },
    "sourceLinks": [
      {
        "label": "Unitree — tableau G1 / G1 EDU et notes",
        "url": "https://www.unitree.com/g1/"
      }
    ],
    "methodText": "Comparaison du tableau constructeur, notamment les notes sur la charge et les configurations. Aucun essai TechniaHQ."
  }
}
},
  {
    "key": "ubtech-walker-s",
    "basePath": "/humanoid-robots/ubtech-walker-s",
    "pageType": "website",
    "method": "robot",
    "modified": "2026-07-18",
    "keywordKeys": [
      "humanoid",
      "china",
      "industrial",
      "automation",
      "wholeBody",
      "companies"
    ],
    "subject": {
  "zh-cn": "优必选 Walker S 工业人形机器人",
  "ja": "UBTECH Walker S 産業用ヒューマノイド",
  "fr": "UBTECH Walker S : données publiées et limites",
  "de": "UBTECH Walker S Industrie-Humanoid"
},
    "title": {
  "zh-cn": "优必选 Walker S：规格、工厂试点与价格状态",
  "ja": "UBTECH Walker Sの仕様・工場実証・価格状況",
  "fr": "UBTECH Walker S : données publiées et limites",
  "de": "UBTECH Walker S Daten und Grenzen der Greifangaben"
},
    "description": {
  "zh-cn": "Walker S 已核实资料：工业用途、身高、重量、自由度、材料搬运、检测、制造辅助和询价状态。",
  "ja": "Walker Sの産業用途、全高、重量、自由度、搬送、検査、製造支援、価格状況を確認します。",
  "fr": "Ce que la page constructeur Walker S documente sur les articulations, la vision RGBD et la préhension, avec les limites des données disponibles.",
  "de": "Walker S laut UBTECH mit 170 cm, 65 kg und 41 Freiheitsgraden. Einordnung der veröffentlichten Greifarchitektur und der fehlenden Leistungsnachweise."
},
    "lead": {
  "zh-cn": "Walker S 面向结构化的工厂和物流流程。公开资料描述材料搬运、检测和制造辅助，但页面不会把公司试点自动描述为无人监督的规模化部署。",
  "ja": "Walker Sは構造化された工場・物流工程を対象とします。搬送、検査、製造支援が公開されていますが、企業PoCを無人の大規模運用とは表現しません。",
  "fr": "UBTECH présente Walker S comme un humanoïde destiné aux lignes de production. La documentation consultée décrit son architecture et des fonctions annoncées ; elle ne fournit pas un bilan de fonctionnement continu chez un client.",
  "de": "Walker S ist UBTECHs ursprüngliches Modell dieser industriellen Baureihe. Die Herstellerseite führt Walker S, Walker S1 und Walker S2 getrennt; diese Angaben beziehen sich auf Walker S."
},
    "facts": [
      {
        "label": {
          "zh-cn": "公开价格",
          "ja": "公開価格",
          "fr": "Prix public",
          "de": "Öffentlicher Preis"
        },
        "value": {
          "zh-cn": "价格需联系销售，未公布统一零售价",
          "ja": "価格は要問い合わせ。統一小売価格は未公表",
          "fr": "Prix sur demande, sans tarif public unique",
          "de": "Preis auf Anfrage, kein einheitlicher Listenpreis veröffentlicht"
        }
      },
      {
        "label": {
          "zh-cn": "身高",
          "ja": "全高",
          "fr": "Hauteur",
          "de": "Höhe"
        },
        "value": {
          "zh-cn": "172厘米",
          "ja": "172 cm",
          "fr": "172 cm",
          "de": "172 cm"
        }
      },
      {
        "label": {
          "zh-cn": "重量",
          "ja": "重量",
          "fr": "Poids",
          "de": "Gewicht"
        },
        "value": {
          "zh-cn": "76千克",
          "ja": "76 kg",
          "fr": "76 kg",
          "de": "76 kg"
        }
      },
      {
        "label": {
          "zh-cn": "自由度",
          "ja": "自由度",
          "fr": "Degrés de liberté",
          "de": "Freiheitsgrade"
        },
        "value": {
          "zh-cn": "41个自由度",
          "ja": "41自由度",
          "fr": "41 degrés de liberté",
          "de": "41 Freiheitsgrade"
        }
      }
    ],
    "related": [
      "humanoid",
      "china-humanoids",
      "unitree-g1",
      "china-prices"
    ],
    "sourceLinks": [
      {
        "label": "UBTECH Walker S",
        "url": "https://www.ubtrobot.com/humanoid/products/walker-s"
      },
      {
        "label": "UBTECH humanoid range",
        "url": "https://www.ubtrobot.com/humanoid"
      }
    ]
  ,
"editorialByLocale": {
  "de": {
    "facts": [
      {
        "label": {
          "de": "Öffentlicher Preis"
        },
        "value": {
          "de": "Kein Listenpreis in den konsultierten UBTECH-Unterlagen"
        }
      },
      {
        "label": {
          "de": "Höhe und Gewicht"
        },
        "value": {
          "de": "170 cm und 65 kg laut Walker-S-Parametergrafik"
        }
      },
      {
        "label": {
          "de": "Freiheitsgrade"
        },
        "value": {
          "de": "41 insgesamt laut UBTECH"
        }
      },
      {
        "label": {
          "de": "Arm und Sensorik"
        },
        "value": {
          "de": "Armlänge 600 mm; RGBD-Sensoren und Kraftfeedback laut Hersteller"
        }
      },
      {
        "label": {
          "de": "Akku"
        },
        "value": {
          "de": "UBTECH nennt ungefähr 2,5 Stunden mit Wechselakku; ein Lastprofil wird dabei nicht angegeben"
        }
      }
    ],
    "sections": [
      {
        "heading": {
          "de": "Wie UBTECH das Greifen beschreibt"
        },
        "body": {
          "de": "Die Produktbeschreibung verbindet RGBD-Wahrnehmung, 3D-Punktwolken und die Schätzung einer Objektpose mit Hand-Auge-Koordination. Die Parametergrafik nennt E-Skin als Option. Aus diesen Angaben lässt sich weder eine serienmäßig vorhandene taktile Hand noch eine Erfolgsquote für das Greifen ableiten."
        }
      },
      {
        "heading": {
          "de": "Welche Leistungsangaben offenbleiben"
        },
        "body": {
          "de": "UBTECH nennt bis zu 300 Nm und 130 U/min für Servomotoren. Die Grafik ordnet diese Höchstwerte keinem einzelnen Gelenk und keiner Belastungsdauer zu. Sie reichen deshalb nicht aus, um eine Traglast am ausgestreckten Arm zu berechnen. Für Fabrikaufgaben fehlen hier dokumentierte Zykluszeiten, Fehlerraten und Angaben zu menschlichen Eingriffen."
        }
      }
    ],
    "sourceLinks": [
      {
        "label": "UBTECH Walker S Produktbeschreibung und Parametergrafiken",
        "url": "https://www.ubtrobot.com/en/humanoid/products/walker-s"
      },
      {
        "label": "Walker S Originalgrafik zu Höhe, Gewicht und DoF",
        "url": "https://owebsite-cdn.ubtrobot.com/resources/image/2024/08/12/578787123286085.png"
      },
      {
        "label": "UBTECH Walker S1 als getrenntes Modell",
        "url": "https://www.ubtrobot.com/en/humanoid/products/walker-s1"
      }
    ],
    "methodText": "Die veröffentlichten Spezifikationen wurden mit den Walker-S-Grafiken abgeglichen. Es handelt sich um Herstellerangaben. TechniaHQ hat weder Traglast noch Greifleistung oder Akkulaufzeit gemessen.",
    "labels": {
      "englishOriginal": "Englische Themenseite",
      "verifiedFacts": "Herstellerangaben zum Walker S"
    },
    "modified": "2026-09-29",
    "independentEdition": true
  },
  "fr": {
    "modified": "2026-09-29",
    "independentEdition": true,
    "facts": [
      {
        "label": {
          "fr": "Structure annoncée"
        },
        "value": {
          "fr": "Environ 1,7 m ; 41 articulations avec retour d’effort"
        }
      },
      {
        "label": {
          "fr": "Perception documentée"
        },
        "value": {
          "fr": "Vision RGBD, capteurs visuels, audio et de distance"
        }
      }
    ],
    "sections": [
      {
        "heading": {
          "fr": "Préhension annoncée, performances non chiffrées"
        },
        "body": {
          "fr": "UBTECH décrit l’estimation de la pose 6D des objets à partir de nuages de points, puis la coordination main–œil pour les saisir. Le texte consulté ne donne pas de taux de réussite, de cadence ni de protocole d’essai pour cette fonction. Les pages Walker S1 et S2 sont distinctes : leurs résultats ne sont pas attribués ici au Walker S."
        }
      }
    ],
    "hideEvidence": false,
    "labels": {
      "englishOriginal": "Page en anglais",
      "verifiedFacts": "Données publiées",
      "evidence": "Sources et méthode"
    },
    "sourceLinks": [
      {
        "label": "UBTECH — Walker S",
        "url": "https://www.ubtrobot.com/en/humanoid/products/walker-s"
      }
    ],
    "methodText": "Lecture du texte de la fiche constructeur. Aucun essai ni vidéo analysée par TechniaHQ ; performances annoncées par UBTECH."
  }
}
},
  {
  "key": "xiaomi",
  "basePath": "/robotics/xiaomi-robotics-1-100k-hours-umi-vla",
  "pageType": "article",
  "method": "article",
  "modified": "2026-08-04",
  "keywordKeys": [
    "physicalAI",
    "vla",
    "robotLearning",
    "embodiedAI",
    "china",
    "simulation"
  ],
  "subject": {
    "zh-cn": "Xiaomi-Robotics-1 视觉语言动作模型",
    "ja": "Xiaomi-Robotics-1 視覚言語行動モデル",
    "fr": "Xiaomi-Robotics-1 : ce que mesurent les expériences",
    "de": "Xiaomi-Robotics-1: Was 100.000 und 20.000 Trainingsstunden belegen"
  },
  "title": {
    "zh-cn": "Xiaomi-Robotics-1：10万小时手持数据训练物理AI",
    "ja": "Xiaomi-Robotics-1：10万時間のUMIデータとVLA",
    "fr": "Xiaomi-Robotics-1 : ce que mesurent les expériences",
    "de": "Xiaomi-Robotics-1: Was 100.000 und 20.000 Trainingsstunden belegen"
  },
  "description": {
    "zh-cn": "分析 Xiaomi-Robotics-1 如何使用超过10万小时UMI手持夹爪轨迹预训练VLA模型，再与真实机器人和指令对齐。",
    "ja": "10万時間超のUMIハンドヘルド軌跡でVLAを事前学習し、実機と指示へ整合するXiaomi-Robotics-1を解説します。",
    "fr": "Distinguer le corpus UMI de plus de 100 000 heures, les expériences sur 20 000 heures et les tests sur des tâches déjà présentes à l’entraînement.",
    "de": "Die Xiaomi-Studie trennt UMI-Datensammlung, Skalierungsversuche und Roboteranpassung. Entscheidend sind die unterschiedlichen Versuchsbedingungen."
  },
  "lead": {
    "zh-cn": "研究测试一种不必把每条演示都直接录在完整机器人上的数据扩展方法。超过10万小时指的是UMI手持夹爪轨迹，而受计算限制的数据和模型扩展实验使用约2万小时。",
    "ja": "すべてのデモを完成ロボットで収録せずにデータを拡張する方法を検証しています。10万時間超はUMIハンドヘルドグリッパー軌跡を指し、計算予算の制約により、スケーリング実験には約2万時間のデータが使われました。",
    "fr": "Les plus de 100 000 heures désignent des trajectoires recueillies avec des pinces portatives UMI et des caméras. Les expériences contrôlées de mise à l’échelle utilisent environ 20 000 heures pour limiter le coût de calcul.",
    "de": "Über 100.000 Stunden beziehen sich laut Studie auf mit Handgreifern und Kameras erfasste UMI-Trajektorien. Für die kontrollierten Skalierungsversuche nutzte das Team aus Rechenbudgetgründen rund 20.000 Stunden."
  },
  "facts": [
    {
      "label": {
        "zh-cn": "训练数据",
        "ja": "学習データ",
        "fr": "Données d’entraînement",
        "de": "Trainingsdaten"
      },
      "value": {
        "zh-cn": "超过10万小时真实世界UMI手持夹爪轨迹",
        "ja": "10万時間超の実世界UMIハンドヘルド軌跡",
        "fr": "Plus de 100 000 heures de trajectoires UMI réelles",
        "de": "Über 100.000 Stunden reale UMI-Handgreifer-Trajektorien"
      }
    },
    {
      "label": {
        "zh-cn": "训练方法",
        "ja": "学習方法",
        "fr": "Méthode",
        "de": "Methode"
      },
      "value": {
        "zh-cn": "先进行无特定本体预训练，再进行跨本体机器人与指令对齐",
        "ja": "本体非依存の事前学習後、複数ロボットと指示へ整合",
        "fr": "Préentraînement indépendant du corps, puis alignement multi-robot et instruction",
        "de": "Körperunabhängiges Vortraining, danach Roboter- und Instruktionsanpassung"
      }
    },
    {
      "label": {
        "zh-cn": "证据标准",
        "ja": "証拠の基準",
        "fr": "Niveau de preuve",
        "de": "Nachweisstandard"
      },
      "value": {
        "zh-cn": "成功率来自团队报告，尚未发现独立真机复现",
        "ja": "成功率は研究チーム報告で、独立した実機再現は未確認",
        "fr": "Résultats rapportés par l’équipe, sans réplication réelle indépendante trouvée",
        "de": "Teamberichtete Ergebnisse; keine unabhängige reale Replikation gefunden"
      }
    }
  ],
  "related": [
    "physical-ai",
    "unitree-g1",
    "robotics-news",
    "china-humanoids"
  ],
  "sourceLinks": [
    {
      "label": "Xiaomi-Robotics-1 — project",
      "url": "https://robotics.xiaomi.com/xiaomi-robotics-1.html"
    },
    {
      "label": "Xiaomi-Robotics-1 — paper",
      "url": "https://arxiv.org/abs/2607.15330"
    }
  ],
  "editorialByLocale": {
    "de": {
      "modified": "2026-09-29",
      "independentEdition": true,
      "hideEvidence": false,
      "pageType": "article",
      "facts": [],
      "sections": [
        {
          "heading": {
            "de": "Was wurde verglichen?"
          },
          "body": {
            "de": "Abschnitt 3.1 vergleicht beim 5B-Modell 12,5, 25, 50 und 100 Prozent dieses 20.000-Stunden-Teilsatzes. Die Modellgrößen 2B, 5B und 10B werden ebenfalls mit 20.000 Stunden verglichen. „100 Prozent“ bedeutet dort nicht 100.000 Stunden."
          }
        },
        {
          "heading": {
            "de": "Was heißt Generalisierung hier?"
          },
          "body": {
            "de": "Nach der Roboteranpassung prüft Abschnitt 3.2 vier Aufgaben: Schuhe verstauen, Taschen packen, Tische ordnen und Sofas aufräumen. Die Aufgaben waren im Post-Training vertreten; neu waren Umgebungen und konkrete Objekte. Das Ergebnis belegt somit keine Bewältigung beliebiger neuer Aufgaben. Die Messungen stammen vom Autorenteam."
          }
        }
      ],
      "methodText": "Auswertung der Version 2 vom 22. Juli 2026, Abschnitte 2.2 und 3.1–3.2. Keine eigene Roboterprüfung.",
      "sourceLinks": [
        {
          "label": "Xiaomi-Robotics-1: Paper, Version 2",
          "url": "https://arxiv.org/html/2607.15330v2"
        },
        {
          "label": "arXiv: Versionsverlauf und Abstract",
          "url": "https://arxiv.org/abs/2607.15330"
        }
      ],
      "labels": {
        "englishOriginal": "Seite auf Englisch",
        "verifiedFacts": "Angaben der Quellen",
        "evidence": "Quellen und Methode"
      }
    },
    "fr": {
      "modified": "2026-09-29",
      "independentEdition": true,
      "facts": [],
      "sections": [
        {
          "heading": {
            "fr": "« 100 % » de quel ensemble ?"
          },
          "body": {
            "fr": "La section 3.1 compare, pour le modèle 5B, 12,5 %, 25 %, 50 % et 100 % du sous-ensemble de 20 000 heures. Les variantes 2B, 5B et 10B sont aussi comparées sur 20 000 heures. Lire « 100 % » comme 100 000 heures attribuerait donc à cette expérience un volume qu’elle n’utilise pas."
          }
        },
        {
          "heading": {
            "fr": "Des environnements nouveaux, des tâches déjà rencontrées"
          },
          "body": {
            "fr": "Après adaptation aux robots, la section 3.2 évalue quatre tâches : ranger des chaussures, remplir des sacs, organiser une table et ranger un canapé. Ces tâches figurent dans le post-entraînement ; les environnements et objets précis sont nouveaux. Cette évaluation ne démontre donc pas la résolution de n’importe quelle tâche inconnue."
          }
        }
      ],
      "hideEvidence": false,
      "labels": {
        "englishOriginal": "Page en anglais",
        "verifiedFacts": "Données publiées",
        "evidence": "Sources et méthode"
      },
      "pageType": "article",
      "sourceLinks": [
        {
          "label": "Xiaomi-Robotics-1 — article, version 2",
          "url": "https://arxiv.org/html/2607.15330v2"
        },
        {
          "label": "arXiv — résumé et historique des versions",
          "url": "https://arxiv.org/abs/2607.15330"
        }
      ],
      "methodText": "Lecture de la version du 22 juillet 2026, sections 2.2 et 3.1–3.2. Résultats de l’équipe auteur ; aucune réplication TechniaHQ."
    }
  }
},
  {
    "key": "japan-humanoids",
    "basePath": "/humanoid-robots/japan",
    "pageType": "article",
    "method": "article",
    "modified": "2026-09-30",
    "keywordKeys": [
      "japan",
      "humanoid",
      "physicalAI",
      "robotics",
      "industrial",
      "wholeBody"
    ],
    "subject": {
  "zh-cn": "日本人形机器人产业",
  "ja": "日本のヒューマノイドロボット",
  "fr": "Humanoïdes japonais : accès aux dossiers",
  "de": "Japanische Robotikprogramme und Firmen"
},
    "title": {
  "zh-cn": "日本人形机器人：企业、研究项目与物理AI",
  "ja": "日本のヒューマノイド：企業・研究・フィジカルAI",
  "fr": "Humanoïdes japonais : accès aux dossiers",
  "de": "Japanische humanoide Roboter Themenübersicht"
},
    "description": {
  "zh-cn": "梳理日本人形机器人企业、历史研究平台、工业机器人、物理AI项目、当前状态和官方来源。",
  "ja": "日本のヒューマノイドロボットを、歴史的研究機、大学・研究機関、企業開発、産業用ロボット、フィジカルAI計画の流れで整理。ASIMOやHRP系などの研究史と現在の開発を分け、公式資料から機体、用途、開発主体、公開仕様を確認します。過去の成果を現在の商用販売や量産実績として扱わず、資料の時期と出典も示します。",
  "fr": "Accès au dossier sur les programmes japonais et coréens et aux fiches d’entreprises japonaises disponibles en français.",
  "de": "Links zu bestehenden TechniaHQ-Seiten über japanische Humanoid-Programme und Robotikunternehmen. Eine datierte Projektchronologie fehlt hier."
},
    "lead": {
  "zh-cn": "日本在人形机器人研究史上具有重要地位，但历史影响力不等于当前商业产品。页面把已经结束的项目、仍在研究的系统、工业机器人企业和新物理AI项目放到有日期的时间线上。",
  "ja": "日本はヒューマノイド研究の歴史で重要ですが、歴史的価値と現在販売中の製品は同じではありません。終了した計画、研究中の機体、産業用ロボット企業、新しいフィジカルAI構想を時系列で整理します。",
  "fr": "Le dossier sur les programmes japonais et coréens et les fiches d’entreprises sont accessibles ci-dessous.",
  "de": "Die verlinkten Seiten behandeln Humanoid-Programme in Japan und Korea sowie japanische Robotikunternehmen. CORLEO ist ein vierbeiniges Mobilitätskonzept; die zugehörige Seite behandelt den angekündigten Entwicklungszeitplan."
},
    "facts": [
      {
        "label": {
          "zh-cn": "覆盖范围",
          "ja": "対象範囲",
          "fr": "Périmètre",
          "de": "Abdeckung"
        },
        "value": {
          "zh-cn": "历史平台、现役研究、工业自动化和新型人形项目",
          "ja": "歴史的機体、現行研究、産業自動化、新規ヒューマノイド計画",
          "fr": "Plateformes historiques, recherche active, automatisation et nouveaux programmes",
          "de": "Historische Plattformen, aktive Forschung, Industrieautomation und neue Programme"
        }
      },
      {
        "label": {
          "zh-cn": "主要企业",
          "ja": "主な企業",
          "fr": "Entreprises citées",
          "de": "Genannte Unternehmen"
        },
        "value": {
          "zh-cn": "本田、丰田、川崎、FANUC、安川电机等",
          "ja": "Honda、Toyota、Kawasaki、FANUC、Yaskawaなど",
          "fr": "Honda, Toyota, Kawasaki, FANUC, Yaskawa et autres",
          "de": "Honda, Toyota, Kawasaki, FANUC, Yaskawa und weitere"
        }
      },
      {
        "label": {
          "zh-cn": "证据标准",
          "ja": "証拠の基準",
          "fr": "Niveau de preuve",
          "de": "Nachweisstandard"
        },
        "value": {
          "zh-cn": "视频日期和项目状态必须同时核实",
          "ja": "映像の日付とプロジェクトの現状を同時に確認",
          "fr": "Date de la vidéo et statut actuel vérifiés séparément",
          "de": "Videodatum und heutiger Projektstatus werden getrennt geprüft"
        }
      }
    ],
    "related": [
      "japan-companies-directory",
      "japan-korea",
      "corleo",
      "fanuc"
    ]
  ,
"editorialByLocale": {
  "de": {
    "pageType": "website",
    "facts": [],
    "sections": [],
    "hideEvidence": true,
    "modified": "2026-09-29",
    "independentEdition": true,
    "labels": {
      "englishOriginal": "Englische Themenseite"
    }
  },
  "fr": {
    "modified": "2026-09-29",
    "independentEdition": true,
    "facts": [],
    "sections": [],
    "hideEvidence": true,
    "labels": {
      "englishOriginal": "Page en anglais",
      "verifiedFacts": "Données publiées",
      "evidence": "Sources et méthode"
    },
    "pageType": "website",
    "related": [
      "japan-korea",
      "japan-companies-directory"
    ]
  }
}
},
  {
  "key": "japan-companies-directory",
  "basePath": "/robotics-companies/country/japan",
  "pageType": "website",
  "method": "company",
  "modified": "2026-08-04",
  "keywordKeys": [
    "japan",
    "companies",
    "industrial",
    "robotics",
    "automation",
    "humanoid"
  ],
  "subject": {
    "zh-cn": "日本机器人企业：三家企业简介",
    "ja": "日本のロボット企業：三社の紹介",
    "fr": "Entreprises japonaises : trois fiches robotiques",
    "de": "Japanische Unternehmensprofile"
  },
  "title": {
    "zh-cn": "日本机器人企业：三家企业简介",
    "ja": "日本のロボット企業：三社の紹介",
    "fr": "Entreprises japonaises : trois fiches robotiques",
    "de": "Japanische Robotikunternehmen Ausgewählte Profile"
  },
  "description": {
    "zh-cn": "FANUC、Kawasaki Robotics 和 Yaskawa Electric 的中文简介，以及日本人形机器人项目入口。",
    "ja": "FANUC、Kawasaki Robotics、Yaskawa Electricの日本語紹介と、日本のヒューマノイド計画への入口。",
    "fr": "Fiches françaises de FANUC, Kawasaki Robotics et Yaskawa Electric, avec un accès distinct aux programmes humanoïdes japonais.",
    "de": "Links zu den deutschsprachigen Profilen von FANUC, Kawasaki Robotics und Yaskawa sowie zur englischen Firmenliste mit den vorhandenen Unternehmenseinträgen."
  },
  "lead": {
    "zh-cn": "下方列出 FANUC、Kawasaki Robotics 和 Yaskawa Electric 三家企业简介。日本人形机器人链接是另一主题入口，不是第四家企业记录。",
    "ja": "下記はFANUC、Kawasaki Robotics、Yaskawa Electricの三社紹介です。日本のヒューマノイドへのリンクは別テーマの入口であり、四社目の企業記録ではありません。",
    "fr": "Les trois fiches d’entreprises disponibles ici concernent FANUC, Kawasaki Robotics et Yaskawa Electric. Le lien consacré aux humanoïdes japonais mène à une rubrique thématique.",
    "de": "Die folgenden Links führen zu drei deutschen Unternehmensprofilen und zur Übersicht japanischer Robotikprogramme. Das ausführlichere Firmenverzeichnis finden Sie auf der englischen Themenseite."
  },
  "facts": [
    {
      "label": {
        "zh-cn": "目录记录",
        "ja": "ディレクトリ登録",
        "fr": "Entrées du répertoire",
        "de": "Verzeichniseinträge"
      },
      "value": {
        "zh-cn": "当前目录中有4家日本企业记录",
        "ja": "現在4社の日本企業を登録",
        "fr": "4 entreprises japonaises actuellement répertoriées",
        "de": "Derzeit 4 japanische Unternehmen erfasst"
      }
    },
    {
      "label": {
        "zh-cn": "覆盖范围",
        "ja": "対象範囲",
        "fr": "Périmètre",
        "de": "Abdeckung"
      },
      "value": {
        "zh-cn": "工业机械臂、协作机器人、运动控制和人形项目",
        "ja": "産業用アーム、協働ロボット、モーション制御、ヒューマノイド計画",
        "fr": "Bras industriels, cobots, contrôle de mouvement et projets humanoïdes",
        "de": "Industrieroboter, Cobots, Motion Control und Humanoid-Projekte"
      }
    },
    {
      "label": {
        "zh-cn": "证据标准",
        "ja": "証拠の基準",
        "fr": "Niveau de preuve",
        "de": "Nachweisstandard"
      },
      "value": {
        "zh-cn": "公司级能力与单个机器人型号的能力分开",
        "ja": "企業の能力と個別機種の能力を分離",
        "fr": "Capacités de l’entreprise séparées de celles d’un modèle",
        "de": "Unternehmenskompetenz getrennt von Fähigkeiten eines Modells"
      }
    }
  ],
  "related": [
    "japan-humanoids",
    "kawasaki-company",
    "fanuc",
    "yaskawa"
  ],
  "editorialByLocale": {
    "de": {
      "facts": [],
      "sections": [],
      "hideEvidence": true,
      "modified": "2026-09-29",
      "independentEdition": true,
      "labels": {
        "englishOriginal": "Englische Themenseite"
      }
    },
    "fr": {
      "modified": "2026-09-29",
      "independentEdition": true,
      "facts": [],
      "sections": [],
      "hideEvidence": true,
      "labels": {
        "englishOriginal": "Page en anglais",
        "verifiedFacts": "Données publiées",
        "evidence": "Sources et méthode"
      },
      "related": [
        "fanuc",
        "kawasaki-company",
        "yaskawa",
        "japan-humanoids"
      ]
    },
    "zh-cn": {
      "independentEdition": true,
      "labels": {
        "englishOriginal": "英文页面",
        "verifiedFacts": "阅读要点"
      },
      "hideEvidence": true,
      "facts": []
    },
    "ja": {
      "independentEdition": true,
      "labels": {
        "englishOriginal": "英語ページ",
        "verifiedFacts": "確認項目"
      },
      "hideEvidence": true,
      "facts": []
    }
  }
},
  {
  "key": "japan-korea",
  "basePath": "/robotics-news/japan-korea-humanoid-programs",
  "pageType": "article",
  "method": "article",
  "modified": "2026-08-04",
  "keywordKeys": [
    "japan",
    "humanoid",
    "robotics",
    "physicalAI",
    "wholeBody",
    "companies"
  ],
  "subject": {
    "zh-cn": "日本与韩国人形机器人项目：核对项目状态",
    "ja": "日本・韓国のヒューマノイド計画：状態の確認",
    "fr": "Programmes humanoïdes au Japon et en Corée vérifier leur statut",
    "de": "Humanoid-Programme in Japan und Korea Projektstatus prüfen"
  },
  "title": {
    "zh-cn": "日本与韩国人形机器人项目：核对项目状态",
    "ja": "日本・韓国のヒューマノイド計画：状態の確認",
    "fr": "Programmes humanoïdes au Japon et en Corée vérifier leur statut",
    "de": "Humanoid-Programme in Japan und Korea Projektstatus prüfen"
  },
  "description": {
    "zh-cn": "Toyota T-HR3、Rainbow Robotics 和 ROBOTIS OP3 官方入口，以及确认型号、最后公告和项目状态的方法。",
    "ja": "Toyota T-HR3、Rainbow Robotics、ROBOTIS OP3の公式入口と、機種、最新発表、計画の状態を確認する項目。",
    "fr": "Liens vers Toyota T-HR3, Rainbow Robotics et ROBOTIS OP3 pour vérifier la date, le modèle et le statut d’un programme.",
    "de": "Links zu Toyota T-HR3, Rainbow Robotics und ROBOTIS OP3 zur Prüfung von Modell, Datum und Projektstatus."
  },
  "lead": {
    "zh-cn": "项目启动日期、最后一次官方更新和当前可用性应分别核实。下方链接指向 Toyota T-HR3、Rainbow Robotics 和 ROBOTIS OP3；本页没有完整的两国项目时间线。",
    "ja": "開始日、最後の公式更新、現在の提供状況は別々に確認します。下記はToyota T-HR3、Rainbow Robotics、ROBOTIS OP3へのリンクで、日本と韓国の全計画をまとめた年表ではありません。",
    "fr": "Les liens ci-dessous renvoient à Toyota T-HR3, Rainbow Robotics et ROBOTIS OP3. La date de début d’un projet, sa dernière annonce officielle et sa disponibilité doivent être vérifiées séparément. Cette page ne fournit pas de chronologie complète des programmes japonais et coréens.",
    "de": "Die folgenden Links führen zu Toyota T-HR3, Rainbow Robotics und ROBOTIS OP3. Projektbeginn, letzte offizielle Meldung und Verfügbarkeit müssen getrennt geprüft werden. Eine vollständige Chronologie japanischer und koreanischer Programme enthält diese Seite nicht."
  },
  "facts": [
    {
      "label": {
        "zh-cn": "主要企业",
        "ja": "主な企業",
        "fr": "Entreprises citées",
        "de": "Genannte Unternehmen"
      },
      "value": {
        "zh-cn": "本田、丰田、KAIST、Rainbow Robotics、ROBOTIS",
        "ja": "Honda、Toyota、KAIST、Rainbow Robotics、ROBOTIS",
        "fr": "Honda, Toyota, KAIST, Rainbow Robotics et ROBOTIS",
        "de": "Honda, Toyota, KAIST, Rainbow Robotics und ROBOTIS"
      }
    },
    {
      "label": {
        "zh-cn": "比较口径",
        "ja": "比較方法",
        "fr": "Méthode de comparaison",
        "de": "Vergleichsmethode"
      },
      "value": {
        "zh-cn": "现役企业、大学平台、政府项目和历史机器人分别记录",
        "ja": "現役企業、大学機、政府計画、歴史的ロボットを分離",
        "fr": "Entreprises actives, universités, programmes publics et robots historiques séparés",
        "de": "Aktive Firmen, Universitätsplattformen, Förderprojekte und historische Roboter getrennt"
      }
    },
    {
      "label": {
        "zh-cn": "状态",
        "ja": "状態",
        "fr": "Statut",
        "de": "Status"
      },
      "value": {
        "zh-cn": "没有覆盖两国所有项目的统一官方注册表",
        "ja": "両国を網羅する単一の公式登録簿はない",
        "fr": "Aucun registre officiel unique ne couvre les deux pays",
        "de": "Kein einheitliches offizielles Register deckt beide Länder ab"
      }
    }
  ],
  "related": [
    "japan-humanoids",
    "japan-companies-directory",
    "corleo",
    "robotics-news"
  ],
  "sourceLinks": [
    {
      "label": "Toyota T-HR3",
      "url": "https://global.toyota/en/detail/19666346"
    },
    {
      "label": "Rainbow Robotics",
      "url": "https://www.rainbow-robotics.com/"
    },
    {
      "label": "ROBOTIS OP3",
      "url": "https://www.robotis.us/robotis-op3-us/"
    }
  ],
  "editorialByLocale": {
    "fr": {
      "independentEdition": true,
      "labels": {
        "englishOriginal": "Page en anglais",
        "verifiedFacts": "Repères de lecture"
      },
      "methodText": "Les liens donnent accès aux documents des fabricants. Aucun décompte de livraisons ni classement de performances n’a été calculé pour cette page.",
      "facts": [
        {
          "label": {
            "fr": "Statut à vérifier"
          },
          "value": {
            "fr": "Prototype de recherche, produit disponible ou projet arrêté"
          }
        },
        {
          "label": {
            "fr": "Date à relever"
          },
          "value": {
            "fr": "Dernière annonce officielle concernant le modèle exact"
          }
        }
      ]
    },
    "de": {
      "independentEdition": true,
      "labels": {
        "englishOriginal": "Seite auf Englisch",
        "verifiedFacts": "Kriterien zum Lesen"
      },
      "methodText": "Die Links führen zu Herstellerdokumenten. Für diese Seite wurden keine Lieferzahlen berechnet und keine Leistungsrangliste erstellt.",
      "facts": [
        {
          "label": {
            "de": "Zu prüfender Status"
          },
          "value": {
            "de": "Forschungsprototyp, verfügbares Produkt oder eingestelltes Projekt"
          }
        },
        {
          "label": {
            "de": "Zu erfassendes Datum"
          },
          "value": {
            "de": "Letzte offizielle Meldung zum genauen Modell"
          }
        }
      ]
    },
    "zh-cn": {
      "independentEdition": true,
      "labels": {
        "englishOriginal": "英文页面",
        "verifiedFacts": "阅读要点"
      },
      "methodText": "下方链接提供官方资料。本页给出阅读字段，未计算交付总数或性能排名。",
      "facts": [
        {
          "label": {
            "zh-cn": "核对字段"
          },
          "value": {
            "zh-cn": "具体型号、最后官方公告、研究或商业状态"
          }
        }
      ]
    },
    "ja": {
      "independentEdition": true,
      "labels": {
        "englishOriginal": "英語ページ",
        "verifiedFacts": "確認項目"
      },
      "methodText": "下記は公式資料へのリンクです。本ページは確認項目を示すもので、納入合計や性能順位は算出していません。",
      "facts": [
        {
          "label": {
            "ja": "確認する項目"
          },
          "value": {
            "ja": "正確な機種、最後の公式発表、研究用か商用か"
          }
        }
      ]
    }
  }
},
  {
  "key": "corleo",
  "basePath": "/robotics/kawasaki-corleo-development-roadmap-2030-2035",
  "pageType": "article",
  "method": "article",
  "modified": "2026-08-04",
  "keywordKeys": [
    "japan",
    "quadruped",
    "physicalAI",
    "robotics",
    "simulation",
    "companies"
  ],
  "subject": {
    "zh-cn": "川崎 CORLEO 四足载人机器人概念",
    "ja": "Kawasaki CORLEO 四足モビリティ構想",
    "fr": "Kawasaki CORLEO : comprendre les objectifs 2027–2035",
    "de": "Kawasaki CORLEO: Was die Termine 2027, 2030 und 2035 bedeuten"
  },
  "title": {
    "zh-cn": "川崎 CORLEO 路线图：2027模拟器、2030世博会、2035商业化",
    "ja": "Kawasaki CORLEO計画：2027年シミュレーター、2030年、2035年",
    "fr": "Kawasaki CORLEO : comprendre les objectifs 2027–2035",
    "de": "Kawasaki CORLEO: Was die Termine 2027, 2030 und 2035 bedeuten"
  },
  "description": {
    "zh-cn": "川崎 CORLEO 的官方开发时间表、骑乘模拟器、2030利雅得世博会目标、2035商业化计划和仍未证明的硬件能力。",
    "ja": "CORLEOの公式日程、2027年ライディングシミュレーター、Expo 2030、2035年商用化目標、未実証の機体性能を整理します。",
    "fr": "Ce que distinguent les annonces Kawasaki : simulateur prévu pour 2027, usage visé à l’Expo 2030 et commercialisation envisagée en 2035.",
    "de": "CORLEOs Simulator, Expo-Einsatz und Vermarktung sind verschiedene Entwicklungsziele. Vergleich der Kawasaki-Ankündigungen von April und Dezember 2025."
  },
  "lead": {
    "zh-cn": "CORLEO 已从遥远概念进入有团队和时间节点的开发计划，但公开展品仍是可摆姿势的概念模型。山地奔跑画面表达的是目标体验，不是已经验证的载人四足运动。",
    "ja": "CORLEOは担当組織と中間目標を持つ開発計画になりましたが、公開展示はポーズ可能なコンセプトモデルです。山岳走行映像は目標体験であり、乗員を載せた実機走行の証明ではありません。",
    "fr": "L’annonce d’avril 2025 présente un concept à l’horizon 2050 et un modèle d’exposition capable de prendre différentes poses. Celle de décembre 2025 annonce une équipe de développement et des objectifs plus proches.",
    "de": "Kawasakis April-Mitteilung beschreibt ein Konzept für 2050 und ein Exponat, das verschiedene Posen zeigt. Die Dezember-Mitteilung nennt ein Entwicklungsteam und frühere Zieltermine. Sie dokumentiert damit eine Projektplanung; Fahrleistung mit Passagier wird darin nicht nachgewiesen."
  },
  "facts": [
    {
      "label": {
        "zh-cn": "时间表",
        "ja": "開発日程",
        "fr": "Calendrier",
        "de": "Zeitplan"
      },
      "value": {
        "zh-cn": "开发目标：2027年骑乘模拟器；2030年利雅得世博会移动体验；2035年商业化",
        "ja": "開発目標：2027年シミュレーター、Expo 2030での移動体験、2035年商用化",
        "fr": "Simulateur 2027, mobilité sur site à l’Expo 2030, objectif commercial 2035",
        "de": "Fahrsimulator 2027, Vor-Ort-Mobilität Expo 2030, Vermarktungsziel 2035"
      }
    },
    {
      "label": {
        "zh-cn": "操控方式",
        "ja": "操縦方法",
        "fr": "Méthode",
        "de": "Methode"
      },
      "value": {
        "zh-cn": "骑手重心控制，并计划加入机器辅助",
        "ja": "乗員の体重移動と将来の機械支援",
        "fr": "Contrôle par déplacement du poids du pilote avec assistance prévue",
        "de": "Steuerung durch Gewichtsverlagerung des Fahrers mit geplanter Assistenz"
      }
    },
    {
      "label": {
        "zh-cn": "状态",
        "ja": "状態",
        "fr": "Statut",
        "de": "Status"
      },
      "value": {
        "zh-cn": "概念模型和正式开发项目，不是已上市产品",
        "ja": "コンセプトモデルと正式開発計画。市販製品ではない",
        "fr": "Modèle conceptuel et programme actif, pas un produit commercialisé",
        "de": "Konzeptmodell und aktives Entwicklungsprogramm, kein Marktprodukt"
      }
    },
    {
      "label": {
        "zh-cn": "证据标准",
        "ja": "証拠の基準",
        "fr": "Niveau de preuve",
        "de": "Nachweisstandard"
      },
      "value": {
        "zh-cn": "未公布自动导航、无骑手运行、速度、续航和载荷数据",
        "ja": "自律航法、無人運転、速度、航続、積載量は未公表",
        "fr": "Autonomie, fonctionnement sans pilote, vitesse, portée et charge non publiés",
        "de": "Autonome Navigation, fahrerloser Betrieb, Tempo, Reichweite und Nutzlast nicht veröffentlicht"
      }
    }
  ],
  "related": [
    "kawasaki-company",
    "japan-humanoids",
    "japan-korea",
    "events"
  ],
  "sourceLinks": [
    {
      "label": "Kawasaki — CORLEO development announcement",
      "url": "https://global.kawasaki.com/en/corp/newsroom/news/detail/?f=20251211_7502"
    },
    {
      "label": "Kawasaki — Expo 2025 concept",
      "url": "https://global.kawasaki.com/en/corp/newsroom/news/detail/?f=20250403_9193"
    }
  ],
  "editorialByLocale": {
    "de": {
      "modified": "2026-09-29",
      "independentEdition": true,
      "hideEvidence": false,
      "pageType": "article",
      "facts": [
        {
          "label": {
            "de": "2027"
          },
          "value": {
            "de": "Ziel: Fertigstellung eines Fahrsimulators"
          }
        },
        {
          "label": {
            "de": "2030"
          },
          "value": {
            "de": "Ziel: Mobilitätsangebot auf der Expo in Riad"
          }
        },
        {
          "label": {
            "de": "2035"
          },
          "value": {
            "de": "Ziel: Vermarktung"
          }
        }
      ],
      "sections": [
        {
          "heading": {
            "de": "Welche Technik ist angekündigt?"
          },
          "body": {
            "de": "Kawasaki beschreibt Gewichtsverlagerung als Steuereingabe, unabhängig vertikal bewegliche Hinterbeine und einen Wasserstoffmotor zur Stromerzeugung. Das sind Herstellerangaben. Ein Simulator prüft nicht die Traglast oder Reichweite des späteren Fahrzeugs. Die beiden Mitteilungen liefern dafür keine Messwerte oder Fahrversuche mit dokumentierten Bedingungen."
          }
        }
      ],
      "methodText": "Verglichen wurden die Kawasaki-Mitteilungen vom 3. April und 3. Dezember 2025; keine eigene Fahrprüfung oder Videoauswertung.",
      "sourceLinks": [
        {
          "label": "Kawasaki — CORLEO development announcement",
          "url": "https://global.kawasaki.com/en/corp/newsroom/news/detail/?f=20251211_7502"
        },
        {
          "label": "Kawasaki — Expo 2025 concept",
          "url": "https://global.kawasaki.com/en/corp/newsroom/news/detail/?f=20250403_9193"
        }
      ],
      "labels": {
        "englishOriginal": "Seite auf Englisch",
        "verifiedFacts": "Angaben der Quellen",
        "evidence": "Quellen und Methode"
      }
    },
    "fr": {
      "modified": "2026-09-29",
      "independentEdition": true,
      "facts": [
        {
          "label": {
            "fr": "2027"
          },
          "value": {
            "fr": "Objectif de réalisation du simulateur de conduite"
          }
        },
        {
          "label": {
            "fr": "2030"
          },
          "value": {
            "fr": "Utilisation visée comme moyen de déplacement à l’Expo de Riyad"
          }
        },
        {
          "label": {
            "fr": "2035"
          },
          "value": {
            "fr": "Commercialisation envisagée"
          }
        }
      ],
      "sections": [
        {
          "heading": {
            "fr": "Un calendrier de développement, pas un essai de locomotion"
          },
          "body": {
            "fr": "Le simulateur prévu pour 2027 est un système distinct du véhicule destiné à transporter un passager. Son achèvement ne démontrerait ni la charge utile ni l’autonomie du CORLEO réel. Les deux annonces ne donnent pas de mesures de déplacement avec pilote assorties de conditions d’essai."
          }
        },
        {
          "heading": {
            "fr": "Architecture annoncée"
          },
          "body": {
            "fr": "Kawasaki décrit une commande par transfert de poids, des jambes arrière mobiles verticalement indépendamment de l’avant et un moteur à hydrogène produisant de l’électricité. Ce sont des caractéristiques annoncées du concept, pas des performances mesurées ici."
          }
        }
      ],
      "hideEvidence": false,
      "labels": {
        "englishOriginal": "Page en anglais",
        "verifiedFacts": "Données publiées",
        "evidence": "Sources et méthode"
      },
      "pageType": "article",
      "sourceLinks": [
        {
          "label": "Kawasaki — CORLEO development announcement",
          "url": "https://global.kawasaki.com/en/corp/newsroom/news/detail/?f=20251211_7502"
        },
        {
          "label": "Kawasaki — Expo 2025 concept",
          "url": "https://global.kawasaki.com/en/corp/newsroom/news/detail/?f=20250403_9193"
        }
      ],
      "methodText": "Comparaison des communiqués Kawasaki du 3 avril et du 3 décembre 2025. Aucun visionnage de démonstration ni essai de conduite TechniaHQ."
    }
  }
},
  {
  "key": "kawasaki-company",
  "basePath": "/robotics-companies/kawasaki-robotics",
  "pageType": "website",
  "method": "company",
  "modified": "2026-08-17",
  "keywordKeys": [
    "japan",
    "companies",
    "industrial",
    "automation",
    "robotics",
    "quadruped"
  ],
  "subject": {
    "zh-cn": "川崎机器人公司",
    "ja": "Kawasaki Robotics",
    "fr": "Kawasaki Robotics : division robot et activités",
    "de": "Kawasaki Robotics: Unternehmen und Produktkatalog"
  },
  "title": {
    "zh-cn": "川崎机器人：工业机器人、协作机器人与自动化产品线",
    "ja": "Kawasaki Robotics：産業ロボット、協働ロボット、自動化",
    "fr": "Kawasaki Robotics : division robot et activités",
    "de": "Kawasaki Robotics: Unternehmen und Produktkatalog"
  },
  "description": {
    "zh-cn": "川崎机器人业务资料：机器人事业总部位于日本明石，产品覆盖3至1500 kg负载，并包括通用工业机器人、CL协作机器人、码垛、拾取、喷涂、焊接和duAro双臂系统。",
    "ja": "Kawasakiのロボット事業本部は兵庫県明石。3～1500 kg可搬の産業ロボット、CL協働ロボット、パレタイジング、ピッキング、塗装、溶接、duAroなどを確認します。",
    "fr": "Repères sur la Robot Business Division de Kawasaki à Akashi et accès à sa documentation officielle de robotique industrielle.",
    "de": "Kawasaki Robotics in Akashi und Neuss: Unternehmensdaten und Links zum offiziellen Industrieroboterkatalog."
  },
  "lead": {
    "zh-cn": "Kawasaki Heavy Industries 的机器人事业总部位于日本兵库县明石。官方产品目录覆盖从小型通用机械臂到1500 kg级超重载机器人，并包括协作、码垛、拾取、焊接、喷涂、半导体和双臂协作系统。",
    "ja": "Kawasaki Heavy IndustriesのRobot Division本部は兵庫県明石です。公式ラインアップは小型汎用ロボットから1500 kg級の超重量可搬機、協働、パレタイジング、ピッキング、溶接、塗装、半導体、双腕協働まで含みます。",
    "fr": "Basée à Akashi au Japon, la Robot Business Division de Kawasaki Heavy Industries présente des robots de soudage, de peinture et de manutention.",
    "de": "Die Robot Division von Kawasaki Heavy Industries hat ihren Hauptsitz in Akashi, Präfektur Hyogo."
  },
  "facts": [
    {
      "label": {
        "zh-cn": "机器人事业总部",
        "ja": "Robot Division本部",
        "fr": "Siège de la Robot Division",
        "de": "Hauptsitz Robot Division"
      },
      "value": {
        "zh-cn": "日本兵库县明石市",
        "ja": "兵庫県明石市、日本",
        "fr": "Akashi, Hyogo, Japon",
        "de": "Akashi, Hyogo, Japan"
      }
    },
    {
      "label": {
        "zh-cn": "官方负载范围",
        "ja": "公式可搬範囲",
        "fr": "Plage de charge utile",
        "de": "Traglastbereich"
      },
      "value": {
        "zh-cn": "3–1500 kg",
        "ja": "3～1500 kg",
        "fr": "3 à 1 500 kg",
        "de": "3 bis 1.500 kg"
      }
    },
    {
      "label": {
        "zh-cn": "主要产品类别",
        "ja": "主なカテゴリ",
        "fr": "Catégories principales",
        "de": "Wichtige Kategorien"
      },
      "value": {
        "zh-cn": "通用工业机器人、CL协作机器人、码垛、拾取、医药、焊接、喷涂、晶圆搬运、duAro双臂",
        "ja": "汎用、CL協働、パレタイジング、ピッキング、医薬、溶接、塗装、ウエハ搬送、duAro",
        "fr": "Robots généralistes, cobots CL, palettisation, picking, médical/pharma, soudage, peinture, wafer transfer, duAro",
        "de": "Universalroboter, CL-Cobots, Palettierung, Picking, Medical/Pharma, Schweißen, Lackieren, Wafer-Transfer, duAro"
      }
    },
    {
      "label": {
        "zh-cn": "欧洲实体",
        "ja": "欧州拠点",
        "fr": "Entité européenne",
        "de": "Europa-Zentrale"
      },
      "value": {
        "zh-cn": "Kawasaki Robotics GmbH，德国诺伊斯，负责欧洲、中东和非洲",
        "ja": "Kawasaki Robotics GmbH（ドイツ・ノイス）、欧州・中東・アフリカ担当",
        "fr": "Kawasaki Robotics GmbH à Neuss, Allemagne, pour l'Europe, le Moyen-Orient et l'Afrique",
        "de": "Kawasaki Robotics GmbH in Neuss, zuständig für Europa, Nahost und Afrika"
      }
    },
    {
      "label": {
        "zh-cn": "日本工业机器人起点",
        "ja": "日本での産業ロボット開始",
        "fr": "Début des robots industriels au Japon",
        "de": "Start der Industrierobotik in Japan"
      },
      "value": {
        "zh-cn": "川崎官方资料记录1969年开始制造日本首台工业机器人",
        "ja": "公式資料では1969年に日本初の産業ロボット製造を開始",
        "fr": "Les sources Kawasaki indiquent un démarrage de la fabrication du premier robot industriel japonais en 1969",
        "de": "Kawasaki nennt 1969 als Beginn der Fertigung des ersten Industrieroboters in Japan"
      }
    }
  ],
  "sections": [
    {
      "heading": {
        "zh-cn": "产品范围远超 BX 和 RS 系列",
        "ja": "BX・RSだけではない製品構成",
        "fr": "Un portefeuille bien plus large que BX et RS",
        "de": "Das Portfolio geht weit über BX und RS hinaus"
      },
      "body": {
        "zh-cn": "官方产品页按通用机器人、协作机器人、码垛、拾取、医药、弧焊、防爆喷涂、晶圆搬运、密封和双臂协作等类别组织产品。单独列出几个系列会低估 Kawasaki 的工业自动化覆盖。",
        "ja": "公式製品ページは汎用、協働、パレタイジング、ピッキング、医薬、アーク溶接、防爆塗装、ウエハ搬送、シーリング、双腕協働などで構成されます。数シリーズだけでは全体を表せません。",
        "fr": "Le catalogue officiel est organisé en robots généralistes, collaboratifs, palettisation, picking, médical/pharma, soudage à l'arc, peinture antidéflagrante, transfert de wafers, sealing et double bras. Résumer Kawasaki à quelques séries sous-estime son portefeuille industriel.",
        "de": "Die offizielle Produktseite gliedert das Portfolio in Universalroboter, Cobots, Palettierung, Picking, Medical/Pharma, Lichtbogenschweißen, explosionsgeschützte Lackierroboter, Wafer-Transfer, Sealing und Dual-Arm-Systeme. Einige Seriennamen bilden das Angebot nicht vollständig ab."
      }
    },
    {
      "heading": {
        "zh-cn": "应用覆盖制造业多个工序",
        "ja": "製造工程を横断する用途",
        "fr": "Des applications sur de nombreux procédés",
        "de": "Anwendungen über viele Fertigungsprozesse"
      },
      "body": {
        "zh-cn": "Kawasaki 官方列出的应用包括装配、搬运、机床上下料、码垛、拾取、喷涂、密封、抛光、去毛刺、弧焊、点焊和晶圆搬运。不同机器人类别针对不同负载、洁净度和安全需求。",
        "ja": "公式には組立、搬送、マシンテンディング、パレタイジング、ピッキング、塗装、シーリング、研磨、バリ取り、アーク・スポット溶接、ウエハ搬送が挙げられています。用途ごとに可搬、清浄度、安全要件が異なります。",
        "fr": "Kawasaki cite l'assemblage, la manutention, le machine tending, la palettisation, le picking, la peinture, le sealing, le polissage, l'ébavurage, le soudage à l'arc et par points et le transfert de wafers. Chaque famille répond à des contraintes différentes de charge, propreté et sécurité.",
        "de": "Kawasaki nennt Montage, Handling, Maschinenbeschickung, Palettierung, Picking, Lackieren, Sealing, Polieren, Entgraten, Lichtbogen- und Punktschweißen sowie Wafer-Transfer. Je nach Prozess unterscheiden sich Traglast-, Reinraum- und Sicherheitsanforderungen."
      }
    },
    {
      "heading": {
        "zh-cn": "欧洲、中东与非洲业务实体",
        "ja": "欧州・中東・アフリカの担当拠点",
        "fr": "En Allemagne, le réseau de service compte aussi",
        "de": "Für Deutschland gehört das lokale Servicenetz zum Profil"
      },
      "body": {
        "zh-cn": "Kawasaki Robotics GmbH 位于德国诺伊斯，并负责欧洲、中东和非洲。各地区的服务范围应向官方窗口核实。",
        "ja": "Kawasaki Robotics GmbHはドイツのノイスにあり、欧州・中東・アフリカを担当します。地域ごとの対応範囲は公式窓口で確認してください。",
        "fr": "Kawasaki Robotics GmbH est à Neuss et couvre l'Europe, le Moyen-Orient et l'Afrique. Pour un lecteur allemand, l'intégration, la formation, le service et le support locaux comptent autant que le catalogue japonais.",
        "de": "Kawasaki Robotics GmbH sitzt in Neuss und betreut Europa, den Nahen Osten und Afrika. Für deutsche Anwender sind neben dem Produktkatalog auch lokale Integration, Schulung, Service und Support relevant."
      }
    }
  ],
  "sourceLinks": [
    {
      "label": {
        "zh-cn": "Kawasaki Robot Division 官方资料",
        "ja": "Kawasaki Robot Division公式情報",
        "fr": "Kawasaki Robot Division officielle",
        "de": "Kawasaki Robot Division – offizielle Unternehmensseite"
      },
      "url": "https://global.kawasaki.com/en/corp/profile/division/robot/index.html"
    },
    {
      "label": {
        "zh-cn": "Kawasaki Robotics 产品目录",
        "ja": "Kawasaki Robotics製品一覧",
        "fr": "Catalogue Kawasaki Robotics",
        "de": "Kawasaki Robotics – Roboterportfolio"
      },
      "url": "https://kawasakirobotics.com/products-robots/"
    },
    {
      "label": {
        "zh-cn": "Kawasaki Robotics 德国/欧洲地址",
        "ja": "Kawasaki Roboticsドイツ拠点",
        "fr": "Kawasaki Robotics Allemagne / Europe",
        "de": "Kawasaki Robotics GmbH – Standort Neuss"
      },
      "url": "https://kawasakirobotics.com/eu-africa/company/locations/"
    }
  ],
  "related": [
    "corleo",
    "japan-companies-directory",
    "fanuc",
    "yaskawa"
  ],
  "editorialByLocale": {
    "de": {
      "modified": "2026-09-29",
      "independentEdition": true,
      "hideEvidence": false,
      "facts": [
        {
          "label": {
            "zh-cn": "机器人事业总部",
            "ja": "Robot Division本部",
            "fr": "Siège de la Robot Division",
            "de": "Hauptsitz Robot Division"
          },
          "value": {
            "zh-cn": "日本兵库县明石市",
            "ja": "兵庫県明石市、日本",
            "fr": "Akashi, Hyogo, Japon",
            "de": "Akashi, Hyogo, Japan"
          }
        },
        {
          "label": {
            "de": "Traglastbereich laut Produktkatalog"
          },
          "value": {
            "zh-cn": "3–1500 kg",
            "ja": "3～1500 kg",
            "fr": "3 à 1 500 kg",
            "de": "3 bis 1.500 kg"
          }
        },
        {
          "label": {
            "zh-cn": "欧洲实体",
            "ja": "欧州拠点",
            "fr": "Entité européenne",
            "de": "Europa-Zentrale"
          },
          "value": {
            "zh-cn": "Kawasaki Robotics GmbH，德国诺伊斯，负责欧洲、中东和非洲",
            "ja": "Kawasaki Robotics GmbH（ドイツ・ノイス）、欧州・中東・アフリカ担当",
            "fr": "Kawasaki Robotics GmbH à Neuss, Allemagne, pour l'Europe, le Moyen-Orient et l'Afrique",
            "de": "Kawasaki Robotics GmbH in Neuss, zuständig für Europa, Nahost und Afrika"
          }
        }
      ],
      "sections": [],
      "sourceLinks": [
        {
          "label": {
            "zh-cn": "Kawasaki Robot Division 官方资料",
            "ja": "Kawasaki Robot Division公式情報",
            "fr": "Kawasaki Robot Division officielle",
            "de": "Kawasaki Robot Division – offizielle Unternehmensseite"
          },
          "url": "https://global.kawasaki.com/en/corp/profile/division/robot/index.html"
        },
        {
          "label": "Kawasaki: Produktübersicht",
          "url": "https://kawasakirobotics.com/products/"
        },
        {
          "label": "Kawasaki Robotics GmbH: Standort Neuss",
          "url": "https://kawasakirobotics.com/emea/company/locations/"
        }
      ],
      "labels": {
        "englishOriginal": "Seite auf Englisch",
        "verifiedFacts": "Angaben der Quellen",
        "evidence": "Quellen und Methode"
      },
      "methodText": "Die Angaben stammen aus den verlinkten Unternehmensdokumenten; sie enthalten keine TechniaHQ-Produktprüfung."
    },
    "fr": {
      "modified": "2026-09-29",
      "independentEdition": true,
      "facts": [
        {
          "label": {
            "fr": "Repère historique"
          },
          "value": {
            "fr": "Kawasaki situe en 1969 la fabrication de son premier robot industriel au Japon"
          }
        }
      ],
      "sections": [],
      "hideEvidence": false,
      "labels": {
        "englishOriginal": "Page en anglais",
        "verifiedFacts": "Données publiées",
        "evidence": "Sources et méthode"
      },
      "sourceLinks": [
        {
          "label": "Kawasaki — Robot Business Division",
          "url": "https://global.kawasaki.com/en/corp/profile/division/robot/index.html"
        }
      ],
      "methodText": "Profil de la division consulté. Les applications citées sont celles du constructeur ; aucune comparaison de robots n’est publiée dans cette fiche."
    }
  }
},
  {
    "key": "fanuc",
    "basePath": "/robotics-companies/fanuc",
    "pageType": "website",
    "method": "company",
    "modified": "2026-07-10",
    "keywordKeys": [
      "japan",
      "companies",
      "industrial",
      "automation",
      "robotics",
      "physicalAI"
    ],
    "subject": {
  "zh-cn": "FANUC 工业机器人",
  "ja": "FANUC 産業用ロボット",
  "fr": "FANUC : robots industriels et commandes numériques",
  "de": "FANUC Industrieroboter"
},
    "title": {
  "zh-cn": "FANUC：工业机器人、CRX协作机器人与工厂自动化",
  "ja": "FANUC：産業用ロボット、CRX協働ロボット、FA",
  "fr": "FANUC : robots industriels et commandes numériques",
  "de": "FANUC Industrieroboter, CRX-Cobots und Fabrikautomation"
},
    "description": {
  "zh-cn": "FANUC 公司资料：山梨总部、1972年成立、工业机器人、CRX协作机器人、CNC、制造和汽车应用。",
  "ja": "FANUCの山梨本社、1972年設立、産業用ロボット、CRX協働ロボット、CNC、製造用途を確認します。",
  "fr": "Repères documentaires FANUC : implantation à Yamanashi, création en 1972 et activités de robotique industrielle et de commande numérique.",
  "de": "FANUC-Profil Sitz in Yamanashi, gegründet 1972, Industrieroboter, CRX-Cobots, CNC und Fertigungsanwendungen."
},
    "lead": {
  "zh-cn": "FANUC 的核心业务是工业机器人、协作机器人、数控和工厂自动化。页面不会因为公司参与 AI 机器人研究，就把所有现有机械臂描述为具身智能或通用人形机器人。",
  "ja": "FANUCの中核は産業用ロボット、協働ロボット、CNC、工場自動化です。AIロボティクス研究への参加だけで、既存アームすべてをフィジカルAIや汎用ヒューマノイドとは呼びません。",
  "fr": "FANUC fabrique des robots industriels et des commandes numériques. La société, créée en 1972, a son siège à Oshino, dans la préfecture de Yamanashi.",
  "de": "FANUC ist Anbieter von Industrierobotern, CRX-Cobots, CNC und Fabrikautomation. Die verlinkten Herstellerseiten dokumentieren den Unternehmenssitz und die Produktbereiche."
},
    "facts": [
      {
        "label": {
          "zh-cn": "总部",
          "ja": "本社",
          "fr": "Siège",
          "de": "Sitz"
        },
        "value": {
          "zh-cn": "日本山梨",
          "ja": "山梨県、日本",
          "fr": "Yamanashi, Japon",
          "de": "Yamanashi, Japan"
        }
      },
      {
        "label": {
          "zh-cn": "状态",
          "ja": "状態",
          "fr": "Statut",
          "de": "Status"
        },
        "value": {
          "zh-cn": "1972年成立，商业运营中",
          "ja": "1972年設立、事業継続中",
          "fr": "Fondée en 1972, entreprise active",
          "de": "1972 gegründet, aktives Unternehmen"
        }
      },
      {
        "label": {
          "zh-cn": "产品",
          "ja": "主な製品",
          "fr": "Produits",
          "de": "Produkte"
        },
        "value": {
          "zh-cn": "FANUC工业机器人、CRX协作机器人、CNC",
          "ja": "FANUC産業用ロボット、CRX協働ロボット、CNC",
          "fr": "Robots industriels FANUC, cobots CRX et CNC",
          "de": "FANUC-Industrieroboter, CRX-Cobots und CNC"
        }
      },
      {
        "label": {
          "zh-cn": "应用行业",
          "ja": "対象産業",
          "fr": "Secteurs",
          "de": "Branchen"
        },
        "value": {
          "zh-cn": "制造、汽车、电子",
          "ja": "製造、自動車、電子",
          "fr": "Industrie, automobile et électronique",
          "de": "Fertigung, Automobil und Elektronik"
        }
      }
    ],
    "related": [
      "japan-companies-directory",
      "kawasaki-company",
      "yaskawa",
      "events"
    ],
    "sourceLinks": [
      {
        "label": "FANUC",
        "url": "https://www.fanuc.com/"
      }
    ]
  ,
"editorialByLocale": {
  "de": {
    "sourceLinks": [
      {
        "label": "FANUC Unternehmensdaten",
        "url": "https://www.fanuc.co.jp/en/profile/outline.html"
      },
      {
        "label": "FANUC Roboterprodukte",
        "url": "https://www.fanuc.co.jp/en/product/robot/"
      }
    ],
    "methodText": "Sitz und Gründungsjahr wurden mit dem Unternehmensprofil abgeglichen. Die Produktzuordnung stammt aus dem FANUC-Katalog. Eigene Messungen oder Vergleiche enthält dieses Kurzprofil nicht.",
    "labels": {
      "englishOriginal": "Englische Themenseite",
      "verifiedFacts": "Unternehmensangaben"
    },
    "facts": [
      {
        "label": {
          "de": "Sitz"
        },
        "value": {
          "de": "Yamanashi, Japan"
        }
      },
      {
        "label": {
          "de": "Status"
        },
        "value": {
          "de": "1972 gegründet, aktives Unternehmen"
        }
      },
      {
        "label": {
          "de": "Produkte"
        },
        "value": {
          "de": "FANUC-Industrieroboter, CRX-Cobots und CNC"
        }
      }
    ],
    "modified": "2026-09-29",
    "independentEdition": true
  },
  "fr": {
    "modified": "2026-09-29",
    "independentEdition": true,
    "facts": [],
    "sections": [],
    "hideEvidence": false,
    "labels": {
      "englishOriginal": "Page en anglais",
      "verifiedFacts": "Données publiées",
      "evidence": "Sources et méthode"
    },
    "sourceLinks": [
      {
        "label": "FANUC — profil officiel",
        "url": "https://www.fanuc.co.jp/en/profile/outline.html"
      }
    ],
    "methodText": "Données du profil officiel. Cette fiche ne contient pas de comparaison de performances ni d’essai de robot.",
    "related": [
      "japan-companies-directory",
      "kawasaki-company",
      "yaskawa"
    ]
  }
}
},
  {
    "key": "yaskawa",
    "basePath": "/robotics-companies/yaskawa-electric",
    "pageType": "website",
    "method": "company",
    "modified": "2026-07-10",
    "keywordKeys": [
      "japan",
      "companies",
      "industrial",
      "automation",
      "robotics",
      "robotLearning"
    ],
    "subject": {
  "zh-cn": "安川电机与 MOTOMAN 机器人",
  "ja": "安川電機とMOTOMANロボット",
  "fr": "Yaskawa Electric : MOTOMAN et servomoteurs",
  "de": "Yaskawa Electric: MOTOMAN und Unternehmensdaten"
},
    "title": {
  "zh-cn": "安川电机：MOTOMAN工业机器人、HC协作机器人与运动控制",
  "ja": "安川電機：MOTOMAN、HC協働ロボット、モーション制御",
  "fr": "Yaskawa Electric : MOTOMAN et servomoteurs",
  "de": "Yaskawa Electric: MOTOMAN und Unternehmensdaten"
},
    "description": {
  "zh-cn": "安川电机资料：北九州总部、1915年成立、MOTOMAN机器人、HC协作机器人、运动控制、制造和物流应用。",
  "ja": "安川電機の北九州本社、1915年創業、MOTOMAN、HC協働ロボット、モーション制御、製造・物流用途を確認します。",
  "fr": "Repères sur Yaskawa Electric à Kitakyushu, fondée en 1915, et sur ses activités de robots industriels et de servomoteurs.",
  "de": "Yaskawa Electric: Sitz, Gründungsdatum und direkte Quellen zu MOTOMAN-Industrierobotern und HC-Cobots."
},
    "lead": {
  "zh-cn": "安川电机把工业机械臂、伺服驱动和运动控制结合在同一自动化体系中。页面重点是可购买产品和实际工业用途，而不是把所有 AI 功能描述为完全自主。",
  "ja": "安川電機は産業用アーム、サーボ、モーション制御を一つの自動化体系で展開しています。購入可能な製品と実際の産業用途を中心にし、AI機能を全面自律と誇張しません。",
  "fr": "Yaskawa Electric fabrique notamment des servomoteurs, des variateurs et des robots industriels commercialisés sous la marque MOTOMAN.",
  "de": "Yaskawa Electric entwickelt Servoantriebe, Motion Control und Industrieroboter. Die Unternehmensdaten nennen Kitakyushu als Hauptsitz und den 16. Juli 1915 als Gründungsdatum."
},
    "facts": [
      {
        "label": {
          "zh-cn": "总部",
          "ja": "本社",
          "fr": "Siège",
          "de": "Sitz"
        },
        "value": {
          "zh-cn": "日本北九州",
          "ja": "北九州、日本",
          "fr": "Kitakyushu, Japon",
          "de": "Kitakyushu, Japan"
        }
      },
      {
        "label": {
          "zh-cn": "状态",
          "ja": "状態",
          "fr": "Statut",
          "de": "Status"
        },
        "value": {
          "zh-cn": "1915年成立，商业运营中",
          "ja": "1915年創業、事業継続中",
          "fr": "Fondée en 1915, entreprise active",
          "de": "1915 gegründet, aktives Unternehmen"
        }
      },
      {
        "label": {
          "zh-cn": "产品",
          "ja": "主な製品",
          "fr": "Produits",
          "de": "Produkte"
        },
        "value": {
          "zh-cn": "MOTOMAN机器人、HC协作机器人",
          "ja": "MOTOMANロボット、HC協働ロボット",
          "fr": "Robots MOTOMAN et cobots HC",
          "de": "MOTOMAN-Roboter und HC-Cobots"
        }
      },
      {
        "label": {
          "zh-cn": "应用行业",
          "ja": "対象産業",
          "fr": "Secteurs",
          "de": "Branchen"
        },
        "value": {
          "zh-cn": "制造、汽车、物流",
          "ja": "製造、自動車、物流",
          "fr": "Industrie, automobile et logistique",
          "de": "Fertigung, Automobil und Logistik"
        }
      }
    ],
    "related": [
      "japan-companies-directory",
      "fanuc",
      "kawasaki-company",
      "events"
    ],
    "sourceLinks": [
      {
        "label": "Yaskawa Electric",
        "url": "https://www.yaskawa-global.com/"
      }
    ]
  ,
"editorialByLocale": {
  "de": {
    "modified": "2026-09-29",
    "independentEdition": true,
    "hideEvidence": false,
    "facts": [
      {
        "label": {
          "zh-cn": "产品",
          "ja": "主な製品",
          "fr": "Produits",
          "de": "Produkte"
        },
        "value": {
          "zh-cn": "MOTOMAN机器人、HC协作机器人",
          "ja": "MOTOMANロボット、HC協働ロボット",
          "fr": "Robots MOTOMAN et cobots HC",
          "de": "MOTOMAN-Roboter und HC-Cobots"
        }
      }
    ],
    "sourceLinks": [
      {
        "label": "Yaskawa: Unternehmensdaten",
        "url": "https://www.yaskawa-global.com/company/profile/data"
      },
      {
        "label": "Yaskawa: Industrieroboter",
        "url": "https://www.yaskawa-global.com/product/robotics"
      },
      {
        "label": "Yaskawa Motoman: HC-Serie",
        "url": "https://www.motoman.com/en-us/products/robots/collaborative/hc-series"
      }
    ],
    "labels": {
      "englishOriginal": "Seite auf Englisch",
      "verifiedFacts": "Angaben der Quellen",
      "evidence": "Quellen und Methode"
    },
    "methodText": "Die Angaben stammen aus den verlinkten Unternehmensdokumenten; sie enthalten keine TechniaHQ-Produktprüfung."
  },
  "fr": {
    "modified": "2026-09-29",
    "independentEdition": true,
    "facts": [
      {
        "label": {
          "fr": "Siège"
        },
        "value": {
          "fr": "Kitakyushu, Japon"
        }
      },
      {
        "label": {
          "fr": "Fondation"
        },
        "value": {
          "fr": "16 juillet 1915"
        }
      }
    ],
    "sections": [],
    "hideEvidence": false,
    "labels": {
      "englishOriginal": "Page en anglais",
      "verifiedFacts": "Données publiées",
      "evidence": "Sources et méthode"
    },
    "sourceLinks": [
      {
        "label": "Yaskawa — données de la société",
        "url": "https://www.yaskawa-global.com/company/profile/data"
      },
      {
        "label": "Yaskawa — robots industriels",
        "url": "https://www.yaskawa-global.com/product/robotics"
      }
    ],
    "methodText": "Profil de société et présentation des robots consultés. Aucun essai ni comparaison de performances TechniaHQ.",
    "related": [
      "japan-companies-directory",
      "fanuc",
      "kawasaki-company"
    ]
  }
}
}
];

export const localizedLocaleOrder = ["en", "zh-cn", "ja", "fr", "de"];

export function normalizeLocalizedBasePath(path = "/") {
  if (!path || path === "/") return "/";
  const clean = String(path).split(/[?#]/)[0].replace(/\/+/g, "/").replace(/\/+$/, "") || "/";
  return clean.startsWith("/") ? clean : `/${clean}`;
}

export function localizedPath(locale, basePath = "/") {
  const normalized = normalizeLocalizedBasePath(basePath);
  if (!locale || locale === "en") return normalized;
  return normalized === "/" ? `/${locale}` : `/${locale}${normalized}`;
}

export function parseLocalizedPriorityPath(path = "/") {
  const normalized = normalizeLocalizedBasePath(path);
  const segments = normalized.split("/").filter(Boolean);
  const first = segments[0] || "";
  const locale = localizedLocales[first] ? first : "en";
  const basePath =
    locale === "en"
      ? normalized
      : segments.length === 1
        ? "/"
        : `/${segments.slice(1).join("/")}`;
  const page = localizedPriorityPages.find(
    (item) => normalizeLocalizedBasePath(item.basePath) === normalizeLocalizedBasePath(basePath),
  );
  return page ? { locale, basePath: normalizeLocalizedBasePath(basePath), page } : null;
}

export function getLocalizedPriorityPage(path = "/") {
  return parseLocalizedPriorityPath(path);
}

export function getLocalizedAlternates(path = "/") {
  const parsed = parseLocalizedPriorityPath(path);
  if (!parsed) return [];
  return localizedLocaleOrder.map((locale) => ({
    hreflang: locale === "en" ? "en" : localizedLocales[locale].lang,
    href: localizedPath(locale, parsed.page.basePath),
    locale,
  }));
}

export function getLocalizedKeywordTerms(page, locale) {
  return (page?.keywordKeys || [])
    .map((key) => localizedKeywordDictionary[key]?.[locale])
    .filter(Boolean);
}

export function getLocalizedPageByKey(key) {
  return localizedPriorityPages.find((page) => page.key === key) || null;
}
